import React, { useState, useEffect, useRef } from "react";
import Cookies from 'js-cookie';
import Config from "../../Config.json";
import gsap from "gsap";
import axios from "axios";
import classNames from "classnames";
import * as fabric from "fabric";

import {stripImg, toTitleCase, humanizeFontWeight, fileNameType, getFileType, fileNameTypeString} from "../../utils/helpers";
import {animDropDown, handleInputFocus, restoreSelection} from "../../utils/form.tools";

import handleMultiSelect from '../narrativeUtils/multiSelect';
import handleAlignUpdate from '../narrativeUtils/alignUpdate';

import { SketchPicker } from 'react-color';
import { EditableInput } from 'react-color/lib/components/common';
import { apiCall } from "../narrativeUtils/fetch";
import Icons from '../module.icons';
import Help from '../module.help';
import Versions from '../module.versions';

import { Fragment } from "react/cjs/react.production.min";
import { isEqual } from "lodash";
import { el } from "date-fns/locale";
import {ReactComponent as AllPhotos} from "../../static/icons/photo_library.svg";
import {ReactComponent as UploadIcon} from "../../static/icons/upload.svg";
import {ReactComponent as ChevronDown} from "../../static/icons/chevron_down.svg" 

const AnimationProperties = [
  {'name': 'opacity', 'slug': 'opacity'},
  {'name': 'x pos', 'slug': 'translateX'},
  {'name': 'y pos', 'slug': 'translateY'},
  {'name': 'scale', 'slug': 'scale'}
]

async function regenerateSvgMarkup(svgJson, newStrokeWidth) {
  // 1. Make a detached <canvas> element
  const canvasEl = document.createElement('canvas');

  // 2. Create a StaticCanvas on it (never appended to the DOM)
  const canvas = new fabric.StaticCanvas(canvasEl, {
    enableRetinaScaling: false,
  });

  return new Promise((resolve) => {
    // 3. Load your JSON onto it
    canvas.loadFromJSON(
      { objects: [ svgJson ], background: canvas.backgroundColor },
      () => {
        
        setTimeout(() => {
            const objects = canvas.getObjects();
          console.log('canvas objects', objects)

          if (objects.length === 0) {
            console.warn("regenerateSvgMarkup: no objects loaded", svgJson);
            // Fallback: emit whatever SVG is currently on the canvas
            const fallbackSvg = canvas.toSVG({ suppressPreamble: true });
            resolve(fallbackSvg);
            return;
          }

          // 4.b Safe to grab first object now
          const obj = objects[0];

          // 5. Update stroke width (and expand obj dims so stroke doesn’t clip)
          obj.set('strokeWidth', newStrokeWidth);
          const halfStroke = newStrokeWidth / 2;

          // obj.scaleToWidth(obj.width + halfStroke * 2)
          // obj.scaleToHeight(obj.height + halfStroke * 2)

          // 6. Resize canvas to fit object
          canvas.width = obj.left + obj.width + halfStroke * 2;
          canvas.height = obj.top + obj.height + halfStroke * 2;

          // 7. Refresh coords and render
          obj.setCoords();
          canvas.renderAll();

          // 8. Grab the new SVG string
          const updatedSvg = canvas.toSVG({ suppressPreamble: true });

          console.log('updatedSvg', updatedSvg, obj)

          resolve(updatedSvg);
        }, 50);
        

 
      }
    );
  });
}

function updateParamString(paramString, key, value) {
  if (key) {
    const params = new URLSearchParams(paramString); // Parse the string
    params.set(key, value); // Update or add the key-value pair
    return params.toString(); // Convert back to a string
  }
}

function parseLinkParams(queryString) {
  let obj = {};

  if (queryString) {
    let params = new URLSearchParams(queryString);

    obj = Object.fromEntries(params.entries());
  }
 
  // console.log('parseLinkParams', obj)
  return obj
}

function LayerSettings(props) {
    // Debounced delayUpdateSVG with persistent timer
    const delayTimerRef = useRef(null);
    const isTypingTimer = useRef();
    const dimCopy = useRef();
    const bgUpdateTimerRef = useRef(null);
    const BG_UPDATE_DELAY = 3000; // ms, wait longer than SketchPicker's own pause
    const [animOpen, setAnimOpen] = useState(false);
    const [editField, setEditField] = useState(null);
    const [tempColor, setTempColor] = useState();
    const [dropDown, setDropDown] = useState();
    const [showAnimPresetDropDown, setShowAnimPresetDropDown] = useState(false);
    const [showAnimDropDown, setShowAnimDropDown] = useState(false);
    const [showNewAnimObj, setShowNewAnimObj] = useState(false);
    const [animPropOn, setAnimPropOn] = useState(null);
    const [selectionCss, setSelectionCss] = useState();
    const [updateSettings, setUpdateSettings] = useState(0);
    const [interaction, setInteraction] = useState(null);
    const [flatHeadings, setFlatHeadings] = useState(null);
    const [backgroundType, setBackgroundType] = useState(null);

    // Debouncer for background color updates
    function scheduleBackgroundUpdate(id, hex) {
      if (bgUpdateTimerRef.current) {
        clearTimeout(bgUpdateTimerRef.current);
      }
      bgUpdateTimerRef.current = setTimeout(() => {
        updateBackgroundColor(id, hex);
      }, BG_UPDATE_DELAY);
    }

    function updateComponentDimension(objID, updates){
      var newComponents = [...props.componentDimensions];
      let newComponent = newComponents.find(obj => obj.id === objID)
      updates.forEach((obj, i) => {
       
        newComponent[obj['field']] = obj['value']

        if (newComponent['svg_json'] && newComponent['svg_json']['objects']) {
            switch (obj['field']) {
              case 'width':
                newComponent['svg_json']['objects'][0].width = obj['value'];
                break;
              case 'height':
                newComponent['svg_json']['objects'][0].height = obj['value']
                break;
              default:
                break;
            }

        }
        if (i === updates.length - 1) {
          // console.log('updateComponentDimension', objID, updates, newComponent)
          props.setComponentDimensions(newComponents)
        }
      })
     

      
    }
    
    function handleAlignSelect(dir, objId) {
      // console.log("handleAlignSelect", dir, objId, props.activeDisplay)
      handleAlignUpdate(dir, objId, props.componentDimensions, props.setComponentDimensions, props.activeDisplay)
      props.setUnSavedChanges(true);
    }

    function getSelectedValue(dimension, name, value) {
   
      let isMixed;
      let result;
      if (selectionCss && selectionCss[name]) {
        result = selectionCss[name];
        if (result === 'mixed') {
          result = "---";
        }


      } else {
        if (dimension.html_text && dimension.html_text.css && dimension.html_text.css[name]) {
          isMixed = showStyleSelected(name, null, dimension);
          switch (name) {
            case "font-weight":
              if (isMixed === 'mixed') {
                result = "---";
              } else {
                result = humanizeFontWeight(dimension.html_text.css[name])
              }
              break;
            default:
              if (isMixed === 'mixed') {
                result = "---";
              } else {
                result = dimension.html_text.css[name];
              }
              break;
          }
        } else {
          switch (name) {
            case "font-size":
              if (isMixed === 'mixed') {
                result = "---";
              } else {
                result = value;
              }
              break;
            default:
              result = <span className="canvasLabel">Add {value} </span>
              break;
          }
        }
      }
      
     

      // console.log('getSelectedValue',  result, selectionCss, dimension.html_text, name, value)
      return result;
    }


    useEffect(() => {
      if (props.activeSettingId) {
        let activeComponent = props.componentDimensions.find(obj => obj.id === props.activeSettingId)
        if (activeComponent && activeComponent.background) {
          setBackgroundType(activeComponent.image ? "Image" : "Color");
        }
      }
    }, [props.componentDimensions, props.activeSettingId])


    useEffect(() => {
     
      if (props.selection && props.selection !== false && props.selection.id) {
        
        // console.log('props.selection', props.selection);
        let tempCss;
        let activeComponent = props.componentDimensions.find(obj => obj.id === props.activeSettingId)
        
        if (activeComponent && activeComponent['html_text'] && activeComponent['html_text']['styleOverrides']) {

          let cssObj = {};

          props.selection.id.forEach(a => {

          
            let overrideObj;
            if (a !== 0) {
              let overrideObj0 = activeComponent['html_text']['styleOverrides'].find(b => b.id === a);
              if (overrideObj0) {
                overrideObj = overrideObj0.css
              }
              // console.log('overrideObj1', overrideObj, a)
            } else {
              overrideObj =  activeComponent['html_text']['css']
              // console.log('overrideObj2', overrideObj)
            }
       

            if (overrideObj) {
              for (const [key, value] of Object.entries(overrideObj)) {
                // console.log(`${key}: ${value}`);
                if (cssObj.hasOwnProperty(key)) {
                  if (cssObj[key] !== value) {
                    cssObj[key] = 'mixed'
                  }
                  if (!cssObj.hasOwnProperty(key)) {
                    cssObj[key] = value
                  }
                } else {
                  cssObj[key] = value
                }
              }
            }
            
            

          })

          
          if (cssObj) {
            tempCss = cssObj;
            setSelectionCss(tempCss);
            // if (tempCss['color']) {
            //   setTempColor(tempCss['color'])
            // }
            // console.log('cssObj', cssObj)

          } else {
            setSelectionCss(null)
          }
        } 
        
          
      } else {
        setTempColor(null)
        setSelectionCss(null);
        // console.log('props.selection FALSE')

      }
      setUpdateSettings(updateSettings+1)
    }, [props.selection])
 

    useEffect(() => {
      if (!props.unSavedChanges && props.activeSettingId && props.componentDimensions) {
        let activeComponent = props.componentDimensions.find(obj => obj.id === props.activeSettingId)
        dimCopy.current = {...activeComponent};
      }
    }, [props.unSavedChanges])

    useEffect(() => {
      if (dropDown) {
        let riseUp = false;
        if (dropDown === 'fontSize') {
          riseUp = true;
        }
        
        animDropDown(true, props.activeSettingId, dropDown, riseUp);
      } else {
        
        
        animDropDown(false, props.activeSettingId, dropDown, false)
      }
    }, [dropDown])


    function handleInteraction(){
      if (props.activeSettingId) {

        let dimension = props.componentDimensions.find(file => (file.id === props.activeSettingId))
        
        if (dimension && dimension.component_link) {
          // console.log('dimension.component_link', dimension.component_link);
          let action = parseLinkParams(dimension.component_link)['action'];
          // let action;
          
          if (action) {
            switch (action) {
              case 'layer':
                setInteraction('Show Layer');
                break;
              case 'page':
                setInteraction('Go to Page');
                break;
              case 'link':
                setInteraction('Go to Link');
                break;
              default:
                break;
            }
            console.log('action', action);
          }

        }

      }
    }

    useEffect(() => {
      if (interaction) {
        setDropDown(null);
        handleInteraction()
        // buildComponentLink("action", interaction);
      } else {

        

        handleInteraction()
      }

    }, [interaction, props.componentDimensions, props.activeSettingId])



    useEffect(() => {
      if (props.narrativeHeadings) {
        let objs = [];
        props.narrativeHeadings.forEach(obj => {
          objs.push(obj)
          obj.subs.forEach(sub => {
            objs.push(sub)
          })
        })
        setFlatHeadings(objs);
      }
    }, [props.narrativeHeadings])

    function handleDropDown(e, field) {
    
      if (field === dropDown) {
        setDropDown(null); 
      } else {
        
        setDropDown(field)
        
      }

    }

  function updateSVG(field, value) {
      let newComponents = [...props.componentDimensions];
      let newComponent = newComponents.find(obj => obj.id === props.activeSettingId)
      // let textCopy = tempTextObj.current;
      // console.log('update', field, value, newComponent)
      let newObj = newComponent['svg_json']['objects'][0];
      if (newObj) {
        if (field === 'strokeWidth') {
          newObj[field] = parseInt(value);
         
        } else {
          newObj[field] = value;
        }

        let svgMarkup = newComponent['svg_markup'];
        // Remove <rect> elements if not a Rect
        if (newObj['type'] !== 'Rect' && svgMarkup) {
          // Remove any <rect> elements from SVG markup when object type isn't Rect
          svgMarkup = svgMarkup
            .replace(/<rect\b[^>]*\/>/gi, '')
            .replace(/<rect\b[^>]*>[\s\S]*?<\/rect>/gi, '');
          newComponent['svg_markup'] = svgMarkup;
        }
        // If we're updating the fill property, also update all inline fill attributes and style rules in the SVG markup
        if (field === 'fill' && svgMarkup) {
          const updatedMarkup = svgMarkup
            .replace(/fill="[^"]*"/g, `fill="${value}"`)
            .replace(/fill:[^;]+;/g, `fill: ${value};`);
          newComponent['svg_markup'] = updatedMarkup;
        }
        if (field === 'stroke' && svgMarkup) {
          const updatedMarkup = svgMarkup
            .replace(/stroke="[^"]*"/g, `stroke="${value}"`)
            .replace(/stroke:[^;]+;/g, `stroke: ${value};`);
          newComponent['svg_markup'] = updatedMarkup;
        }
        if (field === 'strokeWidth' && svgMarkup) {
          const updatedMarkup = svgMarkup
            .replace(/stroke-width="[^"]*"/g, `stroke-width="${value}"`)
            .replace(/stroke-width:[^;]+;/g, `stroke-width: ${value};`);

          newComponent['svg_markup'] = updatedMarkup;

          console.log('newObj', newObj)
          
          regenerateSvgMarkup(newObj, parseInt(value)).then((svgMarkup) => {
            newComponent['svg_markup'] = svgMarkup;
            props.setComponentDimensions(newComponents);

            console.log("regenerateSvgMarkup", newObj, parseInt(value), svgMarkup);
          });
          
          
        }

        
        console.log("updateSVG", field, value, newObj)
        props.setComponentDimensions(newComponents)
        setDropDown(null);
        props.setUnSavedChanges(true);
        
        setTimeout(() => {
          let curr = props.reloadFrame;
          props.setReloadFrame(curr+=1);
        }, 50);
      } 
  }


  function delayUpdateSVG(field, value) {
    if (delayTimerRef.current) {
      clearTimeout(delayTimerRef.current);
    }
    delayTimerRef.current = setTimeout(() => {
      updateSVG(field, value);
    }, 1000);
  }
  

    function animColorPicker(open, id){
      // console.log('animColorPicker', open, id)
        setTempColor(null) 
        setTimeout(() => {
          if (animOpen) {
            gsap.to('.colorPicker', {height: 0, duration: 0});
            gsap.to('.colorPicker', {opacity: 0, y: 0, scale: 0, zIndex: -1, duration: 0.1});
            }
          let posY = document.getElementById(id).offsetTop;
          // let scrollY = document.getElementById('settingsScroll').scrollTop;
          let windowH = window.innerHeight;
          let offsetY = 0;
          if (posY > (windowH - 250)){
            offsetY = -300;
          }
          // console.log('posY', posY, windowH)
          if (open !== id) { 
            let tl = gsap.timeline();
            tl.to("#" + id, {height: "auto", duration: 0});
            tl.to("#" + id, {zIndex: 13, y: offsetY, height: "auto", duration: 0}, "<");
            tl.to("#" + id, {scale: 1, opacity: 1, duration: 0.1});
            setAnimOpen(id);
          } else {
            gsap.to("#" + id, {height: 0, y: 0, duration: 0});
            gsap.to("#" + id, {opacity: 0, scale: 0, zIndex: -1, duration: 0.1});
            setAnimOpen(null);
          }
          props.setUnSavedChanges(true);
        }, 100);
        
    }

    function updateBackgroundColor(objId, color) {
        props.setShowLoader(true);
        const api_url = Config.baseURLcms + 'componentdimension-background/';
    
        let formData = {}
        formData['id'] = objId
        formData['color'] = color
    
        function responseTask() {
          // Temporary workaround for reload bug
          window.location.reload();
        }
        apiCall("POST", api_url, formData, responseTask)
    }
    // Cleanup for background color debouncer
    useEffect(() => {
      return () => {
        if (bgUpdateTimerRef.current) {
          clearTimeout(bgUpdateTimerRef.current);
        }
      };
    }, []);
    
      function handleKeyPress(e, fieldId, fieldValue) {
        if (e.key === "Enter") {
          let newComponents = [...props.componentDimensions];
          let newComponent = newComponents.find(obj => obj.id === props.activeSettingId)
          if (!fieldValue) {
            newComponent[fieldId] = e.target.value;
          } else {
            newComponent[fieldId] = fieldValue;
          }
          // console.log('handleKeyPress', fieldId, fieldValue, newComponent, e.target.value)
          props.setComponentDimensions(newComponents);
          setEditField(null);
          props.setUnSavedChanges(true);
        }
      }
  
      function handleKeyChange(e, fieldId, fieldValue) {
        let newComponents = [...props.componentDimensions];
        let newComponent = newComponents.find(obj => obj.id === props.activeSettingId)
        if (!fieldValue) {
          newComponent[fieldId] = e.target.value;
        } else {
          newComponent[fieldId] = fieldValue;
        }
        // console.log('handleKeyChange', fieldId, fieldValue, newComponent, e.target.value)
        props.setComponentDimensions(newComponents);
        props.setUnSavedChanges(true);
      }

      function buildComponentLink(key,value) {
        if (key !== null){
          console.log("buildComponentLink", key,value);
          let newComponents = [...props.componentDimensions];
          let newComponent = newComponents.find(obj => obj.id === props.activeSettingId);
          let current = newComponent.component_link;
          let newLink = updateParamString(current, key, value);
          if (value === 'link') {
            newComponent['component_link'] = newLink.replace('null=','') + '&module=';
          } else {
            newComponent['component_link'] = newLink;
          }
          
          console.log("newLink", newLink);
          props.setComponentDimensions(newComponents);
          setEditField(null);
          props.setUnSavedChanges(true);
        }
       
      }

      function removeLink(objId) {
        let newComponents = [...props.componentDimensions];
          let newComponent = newComponents.find(obj => obj.id === props.activeSettingId)
          newComponent['component_link'] = '';
          newComponent['component_link_heading'] = '';
       
          setInteraction(null)
          // document.getElementById('link_' + objId).value = ""
          // document.getElementById('link_heading_' + objId).value = ""
          props.setComponentDimensions(newComponents);
          setEditField(null);
          props.setUnSavedChanges(true);
      }

      function handleMediaChoiceValue(mediaChoice, callback) {
        if (mediaChoice === 'vid') {
          props.setAcceptValues("video/mp4");
        } else {
          props.setAcceptValues("image/png, image/jpeg, image/webp, image/svg+xml");
        }
        callback();
      }

      function handleMediaReplace(isBackground, mediaChoice, componentdimension_id, e, isFileOn) {
        props.setZoomNumber(1);
        // var fileList = document.getElementById('fileReplace').files;
        var fileList = e.target.files;
        // console.log('handleMediaReplace', componentdimension_id, fileList);
        var arrayLength = fileList.length;
        for (var i = 0; i < arrayLength; i++) {
          var mediaData = {
            'display': props.aspectRatio,
            'componentdimension_id': componentdimension_id,
            'file': fileList[i],
            'format': mediaChoice
          }
          var currNewMedia = [...props.newMedia];
          currNewMedia.push(mediaData);
          props.setNewMedia(currNewMedia);
  
          const api_url = Config.baseURLcms + 'section-component-replace/';
  
          props.setShowLoader(true);
          var formData = new FormData();
          var fileField = 'image';
          if (mediaChoice === 'svg') {
            var fileField = 'svg';
          }
          if (mediaChoice === 'vid') {
            var fileField = 'video';
          }
          if (isFileOn) {
            var fileField = 'image_on';
          }

          let sizeMB = parseFloat(fileList[i].size / (1024 ** 2)).toFixed(2);
          let sizeKb = fileList[i].size/1024;

          // console.log(sizeMB, sizeKb)
  
          if ((sizeMB > props.user.org.validations.maxFileSize) && (sizeKb > 0)) {
              let newError = {
                "heading": "Error",
                "text": "The selected file is <strong>" + sizeMB + "MB</strong>.<br/>This file exceeds maximum upload size of <strong>10MB</strong>.<br/><br/>Please select a new file that is less than 10MB."
              };
              props.setFormError(newError);
              props.setShowLoader(false);

          } else if (fileList[i].name.startsWith(".")) {
            let newError = {
              "heading": "Error",
              "text": "Please select a valid image file."
            };
            props.setFormError(newError);
            props.setShowLoader(false);

          } else {

  
            formData.append(fileField, fileList[i], fileList[i].name) 
            formData.append('id', componentdimension_id);
            formData.append('display_id', 1);
            formData.append('file_format', mediaChoice);
            if (isBackground) {
              formData.append('background', true);
            } else {
              formData.append('background', false);
            }
            function responseTask() {
              function callback() {
                props.showSettings(componentdimension_id, false, e)
              }
              props.fetchJSON(props.activeSectionObj.id, null, null, callback());
            }
    
            let formHeaders = {
              'Content-Disposition': 'attachment; filename=' + fileList[i].name,
              'Authorization': 'Token ' + Cookies.get('_expo_tokenid')
            }
            apiCall("POST", api_url, formData, responseTask, formHeaders, props.setFormError, props.setShowLoader)

          }
        }
      }
    
      function handleShowStateOptions(objID) {
        var newComponents = [...props.componentDimensions];
        var newIndex = newComponents.findIndex(item => item.id === objID);
        var newObj = newComponents[newIndex];
        newObj['has_state_images'] = true;
        props.setComponentDimensions(newComponents);
        props.setUnSavedChanges(true);
      }

      function handleStateMediaAddReplace(dimensionId, e, stateId, stateHeading) {
        console.log('handleStateMediaAddReplace', dimensionId, e, stateId);
        var fileList = e.target.files;
        var arrayLength = fileList.length;
        for (var i = 0; i < arrayLength; i++) {
          const api_url = Config.baseURLcms + 'componentdimension-stateimg-add/';
  
          props.setShowLoader(true);
          var formData = new FormData();

          let type = getFileType(fileList[i].name);

          if (type === 'vid') {
            formData.append('video', fileList[i], fileList[i].name) 
            console.log('video',  fileList[i], fileList[i].name)
     
          } else {
            formData.append('image', fileList[i], fileList[i].name) 
         
          }
          

          formData.append('componentdimension', dimensionId);
          formData.append('state_id', stateId)
  
          console.log('state_id', stateId)
          formData.append('state_heading', stateHeading)
  
          function responseTask() {
            function callBack() {
                let int = props.updateFetch + 1;
                props.setUpdateFetch(int)
            }
            props.fetchJSON(false, false, false, callBack)
          }
  
          let formHeaders = {
            'Content-Disposition': 'attachment; filename=' + fileList[i].name,
            'Authorization': 'Token ' + Cookies.get('_expo_tokenid')
          }
         
          apiCall("POST", api_url, formData, responseTask, formHeaders, props.setFormError, props.setShowLoader)
      
        }
      }

      function handleLinkMediaAddReplace(dimensionId, e, del) {
        console.log('handleLinkMediaAddReplace', dimensionId, e);

        props.setShowLoader(true);
        const api_url = Config.baseURLcms + 'componentdimension-linkmedia/';
        var formData = new FormData();
        formData.append('id', dimensionId);
        let formHeaders;

        function responseTask() {
          // function callBack() {
          //     let int = props.updateFetch + 1;
          //     props.setUpdateFetch(int);

          // }
          // props.fetchJSON(false, false, false, callBack)
          // Workaround
          window.location.reload();
          
        }
        

        if (del) {
          formHeaders = {
            'Authorization': 'Token ' + Cookies.get('_expo_tokenid')
          }

           formData.append('del', null) 
           apiCall("POST", api_url, formData, responseTask, formHeaders, props.setFormError, props.setShowLoader)

        } else {
          props.setZoomNumber(1)
          var fileList = e.target.files;
          var arrayLength = fileList.length;
          for (var i = 0; i < arrayLength; i++) {
            
            let type = getFileType(fileList[i].name);
            if (type === 'vid') {
              // formData.append('video', fileList[i], fileList[i].name) 
              console.log('video',  fileList[i], fileList[i].name)
      
            } else {
              formData.append('image_on', fileList[i], fileList[i].name) 
            }
            handleKeyChange(e, 'image_on', 'img/' + fileList[i].name)
            handleKeyChange(e, 'name_on', 'img/' + fileList[i].name)

            formHeaders = {
              'Content-Disposition': 'attachment; filename=' + fileList[i].name,
              'Authorization': 'Token ' + Cookies.get('_expo_tokenid')
            }
            apiCall("POST", api_url, formData, responseTask, formHeaders, props.setFormError, props.setShowLoader)
        
          }
        }
        
      }

      function delayedUpdateText(field, value) {
        clearTimeout(isTypingTimer.current);
        if (value) {
          isTypingTimer.current = setTimeout(function(){ updateText(field, value) }, 1000);
        }
      }
      


      function processStyleOverride(selectionID, charIndex, styleOverrides, field, value, unSavedCss){
        // Set the value for this field in the selection CSS
        let styleCount = 1;
        let styleId;
        let sameStyle = false;
        let styleObj = {};
        // console.log('processStyleOverride', selectionID, charIndex, styleOverrides, field, value, unSavedCss)
         // 2.1.1. Find and clone the style of that ID
         if (styleOverrides) {
          let clone = structuredClone(styleOverrides.find(a => a.id === selectionID));
          if (clone) {
            styleObj['css'] = clone.css
          } else {
            // If no style found start from layer CSS
            styleObj['css'] = structuredClone(unSavedCss);
          }
         } else {
          styleObj['css'] = structuredClone(unSavedCss);
         }
        styleObj['css'][field] = value;
        // If there are existing Style Override objs, check if they match the new selection CSS created
        if (styleOverrides) {
          sameStyle = styleOverrides.findIndex((o) => isEqual(o['css'], styleObj['css'])); 
        } else {
          styleOverrides = []
        }
        // console.log('sameStyle', sameStyle, styleObj)
        // If the selection CSS matches a current Style Override, apply that style ID to the character
        if (sameStyle > -1 && styleOverrides.length > 0) {
          styleId = styleOverrides[sameStyle].id
        } else {
          // If the selection CSS matches the base dimension CSS, apply that style ID to the character: 0.
          if (isEqual(unSavedCss, styleObj['css'])) {
            styleId = 0;
          } else {
            // Count the number of existing style overrides and assign a unique ID number to this new style created using this number as a variable and add this style to the array
            if (styleOverrides) {
              styleCount = styleOverrides.length + 1
            }
            // else {
            //   newComponent['html_text']['styleOverrides'] = [];
            // }
            function checkForUniqueness(styleId){
              return styleOverrides.findIndex(a => a.id === styleId) > -1
            }
           
            do {
              styleCount+=1
            } while (checkForUniqueness('1:' + styleCount)) 
            
            styleId = '1:' + styleCount
            styleObj['id'] = styleId;
            // newComponent['html_text']['styleOverrides'].push(selectionCss);
          }
        }
        // console.log("processStyleOverride result", {index: charIndex, id: styleId, styleObj: styleObj})
        return {index: charIndex, id: styleId, styleObj: styleObj}
      }



      // updateText0
      function updateText(field, value) {

        console.log('updateText', field, value)

         // 1. Find the active obj, current dimension CSS, field, value 
        let newComponents = [...props.componentDimensions];
        let newComponent = newComponents.find(obj => obj.id === props.activeSettingId)
        let unSavedCss;

        if (props.tempText) {
          newComponent['html_text'] = structuredClone(props.tempText);
          unSavedCss = structuredClone(props.tempText['css'])
          console.log('updateText with tempText', props.tempText)
        } else {
          unSavedCss = structuredClone(newComponent['html_text']['css'])
        }
        
        let elem = document.getElementById('inputField_' + field + "_text_" + newComponent.id);
        if (elem) {
          elem.value = value;
        } 
      
        // 2. Check if there is an active selection of characters
        if ( props.selection && props.selection.range &&  props.selection.range.length > 0) {
          
          // 2.1. SELECTION FOUND: Check if there is only one Style Override ID present for selected characters
          let charToUpdate = [];
          let overRides = [];
          let styles = [];
          let selectionCss = {};

          props.selection.id.forEach((id, index) => {
            let result = processStyleOverride(id, index+props.selection.selectionRange[0], newComponent['html_text']['styleOverrides'], field, value, unSavedCss)
              if (result) {
                charToUpdate.push(result);
                if (result.styleObj) {
                  if (newComponent['html_text']['styleOverrides']) {
                    newComponent['html_text']['styleOverrides'].push(result.styleObj);
                  } else {
                    newComponent['html_text']['styleOverrides'] = [result.styleObj]
                  }
                 
                }
                
                // console.log('processStyleOverride done', result)
              }
          });
          
          // console.log('props.selection', props.selection)
          // Create a new array of character overrides using style ID created, for all the new characters selected (present in the array as '1');
          props.selection.range.forEach((o, index)=> {
            if (o === 1) {
            
              let newStyle = charToUpdate.find(a => a.index === index);
              console.log('charToUpdate', charToUpdate, index, newStyle)
              if (!newStyle) {
                overRides.push(0)
              } else {
                if (newStyle && newStyle.id !== 0 && newStyle.id !== undefined){
                  overRides.push(newStyle.id)
                } else {
                  overRides.push(0)
                  console.log('error, no style id found', charToUpdate, index, newStyle)
                }
              }
              
            } else {
              overRides.push(o)
            }
          })
          console.log('overRides', overRides)
          
          newComponent['html_text']['charStyleOverrides'] = overRides;

          let currStyles = newComponent['html_text']['styleOverrides'];

          newComponent['html_text']['charStyleOverrides'].forEach((id) => {
            let styleIndex = currStyles.findIndex((a, i) => a.id === id);
            let newStyleIndex = styles.findIndex((a, i) => a.id === id);
            if (styleIndex > -1 && newStyleIndex === -1) {
              styles.push(currStyles[styleIndex])
            }
          });

          newComponent['html_text']['styleOverrides'] = styles;
          console.log("Style Overrides", newComponent['html_text'], props.selection)

        } else {
          

          // 2.2. NO SELECTION FOUND: This is a block level update when users select the dimension/layer itself and do not make a text selection. I.e. there are no active selections. Save the new style and remove any applicable style overrides. NB: this could be simplified at this point probably.
          let newObjCss;
          let deleteStyleIds = [];
          let cleanedOverrides = [];

          if (newComponent['html_text']['css']) {
            newObjCss = newComponent['html_text']['css'];
          } else {
            newObjCss = {}
          }
  
          newObjCss[field] = value;
          let overRides = []
          if (newComponent['html_text']['styleOverrides']) {
            overRides = [...newComponent['html_text']['styleOverrides']];
          }
        
          overRides.forEach((overRide, h) => {
            for (const prop in overRide['css']) {
              if (prop === field) {
                overRide['css'][prop] = value
              }
            }
          })

          overRides.forEach((obj, i) => {
            if (isEqual(obj['css'], newComponent['html_text']['css'])) {
              console.log('match', obj['css'], newComponent['html_text']['css'])
              deleteStyleIds.push(obj.id);
     
            } else {
              cleanedOverrides.push(obj)
            }
          })
          
          if (newComponent['html_text']['charStyleOverrides']) {
            newComponent['html_text']['charStyleOverrides'].forEach((obj, i) => {
              if (deleteStyleIds.findIndex(a => a === obj) > -1) {
                newComponent['html_text']['charStyleOverrides'][i] = 0
              }
            })
            
            if (newComponent['html_text']['charStyleOverrides'].findIndex(b => b !== 0) === -1) {
              delete newComponent['html_text']['charStyleOverrides']
            }
          }

          if (cleanedOverrides.length === 0) {
            delete newComponent['html_text']['styleOverrides']
          } else {
            newComponent['html_text']['styleOverrides'] = overRides
          }

          console.log('overrides', cleanedOverrides, deleteStyleIds)
          console.log("Style Update", newComponent['html_text'])
        }

        setTempColor(null);
        setAnimOpen(null);
        props.setComponentDimensions(newComponents);
        props.setTempText(null);
        setDropDown(null);
        setUpdateSettings(updateSettings+1);
        props.setUnSavedChanges(true);
    

      }
      
      // function handleAddPopup(objID, format) {
      //   console.log('handleAddPopup', objID);
      //   if (format === 'img') {
      //     props.setAcceptValues("image/png, image/jpeg, image/webp");
      //   } 
      //   if (format === 'vid') {
      //     props.setAcceptValues("video/mp4");
      //   }
      //   if (format==='svg') {
      //     props.setAcceptValues("image/svg+xml");
      //   }
      //   var fileElem = document.getElementById('popUpload');
      //   setTimeout(() => {
      //     fileElem.click();
      //   }, 150);
  
      // }

      function handleShowAnimDropDown() {
        if (showAnimDropDown) {
          setShowAnimDropDown(false);
        } else {
          setShowAnimDropDown(true);
        }
      }

      function handleAnimChoice(typeName, objID){
        // console.log('handleAnimChoice', typeName, objID)
        var newComponents = [...props.componentDimensions];
        var newIndex = newComponents.findIndex(item => item.id === objID);
        var newObj = newComponents[newIndex];
        if (typeName !== 'none') {
          newObj['typeName'] = typeName;
        } else {
          newObj['typeName'] = "";
        }
        setShowAnimDropDown(false);
        props.setComponentDimensions(newComponents);
        if (!props.unSavedChanges) {
          props.setUnSavedChanges(true);
        }
        
  
        // console.log("handleAnimChoice", typeName, objID,  newObj['typeName'])
      }

      function handleAnimValue(componentID, animationID, key, value, e) {
        if (e !== "dropdown") {
          e.target.classList.add('editing');
        }
        
        
        if ((e.key === "Enter")||(e === "dropdown")) {
          if (e !== "dropdown") {
            e.target.classList.remove('editing');
          }
          
          props.stageLayerIds(componentID) 

         
  
          var newComponents = [...props.componentDimensions];
          var newIndex = newComponents.findIndex(item => item.id === componentID);
          var newObj = newComponents[newIndex];
          var newAnimIndex = newObj['animations'].findIndex(item => item.id === animationID);
          var newAnimObj = newObj['animations'][newAnimIndex];
  
          if ((key === "delay")||(key === "duration")) {
            // console.log('value', value, parseFloat(value).toFixed(2))
            if (typeof value === "string") {
              value = parseFloat(value)
              if (e.target) {
                e.target.value = value
              }
              
              // console.log('value', value, parseFloat(value).toFixed(2))
            }
  
          }
          newAnimObj[key] = value; 
          
          var dropdowns = document.getElementsByClassName('inputDropDown');
          // console.log('dropdown', dropdowns);
          var i;
          for (i = 0; i < dropdowns.length; i++) {
            dropdowns[i].classList.add('off');
          }
          if (e !== "dropdown") {
            e.target.classList.remove('on');
          }
          
          // console.log('handleAnim', componentID, animationID, key, value, e, newComponents)
          props.setComponentDimensions(newComponents);
          props.setUnSavedChanges(true);

        }
   
       
   
        
  
        
    }
    
      function handleDropDownValue(e, value, id, id2, componentID, animationID, key) {
        // console.log('handleDropDownValue', e, value, id, id2, componentID, animationID, key)
        let elem = document.getElementById(id);
        elem.value = value;
    
        let elem2 = document.getElementById(id2);
        elem2.classList.add('off');
    
        var onInputs = document.querySelectorAll('.valueInput.on');
        var i;
        for (i = 0; i < onInputs.length; i++) {
          onInputs[i].classList.remove('on');
        }
        
        if (componentID && animationID) {
          handleAnimValue(componentID, animationID, key, value, 'dropdown')
        } else {
          handleNewAnimValue(key, value, e);
        }
        
      }
      function handleNewAnimValue(key, value, e) {
        if (Object.keys(props.newAnimObj).length > 0) {
          var animObj = Object.assign({}, props.newAnimObj);
        } else {
          var animObj = {};
        }
        animObj[key] = value;
        props.setNewAnimObj(animObj);
    
        console.log('animObj', animObj, key, value);
    
        if (key === 'property') {
          // animPropRef.current = value;
          setAnimPropOn(value);
          
        }
    
        // console.log('handleNewAnimValue', handleNewAnimValue);
      }

      function handleAspectLock(objID) {
        if (props.showFormatLockWarning !== false) {
          var newComponents = [...props.componentDimensions];
          var newIndex = newComponents.findIndex(item => item.id === objID);
  
          console.log('isLocked', newIndex, objID);
  
          var newObj = newComponents[newIndex];
          var is_locked = newObj['is_locked'];
  
        
          if (is_locked === true) {
            newObj['is_locked'] = false;
  
          } else {
            newObj['is_locked'] = true;
          }
          props.setComponentDimensions(newComponents);
          props.setUnSavedChanges(true);
          props.setShowFormatLockWarning(false);
        } else {
          let isLocked = props.componentDimensions.find(a => a.id === objID).is_locked
          console.log('isLocked Warning', isLocked)

          props.setShowFormatLockWarning([objID, isLocked]);
        }
        
      }

     

      function updateDimension(e, id, mode, val, val2) {
        // console.log('updateDimension recd', e, id, mode, val)
         props.setUnSavedChanges(true);
       
        let updates = []
        let update = {'field': null, 'value': null};
        updates.push(update);
        update['field'] = mode;
        switch (mode) {
          case 'autoplay':
            update['value'] = val;
            break;
          case 'loop':
            update['value'] = val;
            break;
          case 'popup_pos':
            update['value'] = val;
            break;
          default:
            update['value'] = parseInt(e.target.value);
            break;
        }

        if (mode === 'opacity' && (update['value'] > 100)) {
          update['value'] = 100
         
        } 

        console.log('updateDimension', e, id, mode, val, val2, updates)
       

  
        // updateComponentDimension(id, mode, e.target.value)

        if (props.lockAr && (mode === "width" || mode === "height")) {
          let input;
          let newValue;
          let update2 = {'field': null, 'value': null};
          updates.push(update2);
          if (mode === "width") {
            input = document.getElementById('height_dim_' + id)
            newValue = e.target.value/(val/val2)
            
            
            update2['field'] = 'height';
            update2['value'] = parseInt(newValue);
            // updateComponentDimension(id, "height", e.target.value)
          } else {
            input = document.getElementById('width_dim_' + id)
            newValue = e.target.value*(val/val2)
            update2['field'] = 'width';
            update2['value'] = parseInt(newValue);
            // updateComponentDimension(id, "width", e.target.value)
          }
          
          if (props.multiSelectIds && props.multiSelectIds.length > 0) {
            props.multiSelectIds.forEach(a => {
              updateComponentDimension(a, updates)
            })
          } else {
            updateComponentDimension(id, updates)
          }
          
          input.value = Math.round(newValue);
          props.setUnSavedChanges(true);
          
     
        }  else {

          if (props.multiSelectIds && props.multiSelectIds.length > 0) {
            props.multiSelectIds.forEach(a => {
              updateComponentDimension(a, updates)
            })
          } else {
            updateComponentDimension(id, updates)
          }
         
          props.setUnSavedChanges(true);
        }

      }

      function delayUpdateDimension(e, id, mode, val, val2){
        let event = e;
        const timeOutId = setTimeout(() => updateDimension(event, id, mode, val, val2), 1000);
        return () => clearTimeout(timeOutId);
      }

      function handleAddAnimation(dataJSON, fetch, activeSectionId) {
        props.setZoomNumber(1);
        props.showSettings(props.activeSettingId, true, null)
        // let ready;
        // do {
        //   if (!props.unSavedChanges) {
        //     ready = true
        //   } 
        // }
        // while (ready === false)

        const api_url = Config.baseURLcms + 'componentdimension-animation-add/';

        console.log('handleAddAnimation', dataJSON, fetch)
        function responseTask() {
          // props.fetchSection(props.sectionId)
          fetch && props.fetchJSON(activeSectionId)
          
          // setTimeout(() => {
          //   props.showSettings(props.activeSettingId, true, null)
          // }, 1000);
          // props.fetchJSON()
          // console.log('anim ready')
        }
        apiCall('POST', api_url, dataJSON, responseTask)
      }
  

      function runAnimPreset(obj, componentDimensionId, isLocked, displayName, partnerIds, isSimple) {
        console.log('runAnimPreset', obj['presetitems'], isLocked);
    
        let presets = obj['presetitems'];
        presets.forEach((item) => {
         var animDataJSON = {
          'componentdimension': componentDimensionId,
          'property': item.property,
          'start': item.start,
          'end': item.end,
          'startParallax': item.startParallax,
          'endParallax': item.endParallax,
          'duration': item.duration,
          'delay': item.delay,
          'ease': item.ease,
          'is_state': false,
          'preset_id': obj.id
         }
         if (isLocked === true) {
            handleAddAnimation(animDataJSON, true, props.activeSectionObj.id);
            partnerIds && partnerIds.forEach((id) => {
              animDataJSON['componentdimension'] = id;
              // console.log('id', id, animDataJSON);
              handleAddAnimation(animDataJSON, false, props.activeSectionObj.id);
            });
        } else {
          handleAddAnimation(animDataJSON, true, props.activeSectionObj.id);
        }
        })

        props.setShowLoader(true);
        setDropDown(null)
        setShowAnimPresetDropDown(false);
      }

      function handleDeleteAnim(objID) {
        props.setZoomNumber(1)
        var dataJSON = {
          'animation_id': objID
        }
        const api_url = Config.baseURLcms + 'componentdimension-animation-delete/';
        function responseTask() {
          // props.fetchSection(props.sectionId)
          props.fetchJSON(props.activeSectionObj.id)
        }
        apiCall('POST', api_url, dataJSON, responseTask)
       
      }
      
      function handleAddNewAnimation() {
        var animObj = {};
        animObj['duration'] = '';
        animObj['delay'] = '';
        animObj['ease'] = 'default';
        animObj['start'] = '';
        animObj['end'] = '';
        animObj['is_state'] = false;
        props.setNewAnimObj(animObj);
        setShowNewAnimObj(true);
       
        var newValueInputs = document.getElementsByClassName('newValueInput');
        console.log('newValueInputs', newValueInputs);
        var i;
        for (i = 0; i < newValueInputs.length; i++) {
          newValueInputs[i].value = "";
          // console.log('handleAddNewAnimation', newValueInputs, newValueInputs[i], newValueInputs[i].value);
        }
        
      }
    
      function handleDeleteMedia(objID, file_format) {
        props.setShowLoader(true);
        props.setZoomNumber(1);
        props.showSettings(objID, false, null);
        props.setActiveSettingId(null);

        const api_url = Config.baseURLcms + 'section-componentdimension-delete/';
        var dataJSON = {
          'displaycomponent_id': objID,
        }
        function responseTask() {
           window.location.reload();
          // if (file_format === 'svg') {
          //   window.location.reload();
          // } else {
          //    props.updateVersionHistorySub(props.section, "page")
          //   props.setUnSavedChanges(false);


          //     // function callBack(){
       
          //     // }
          //     // props.fetchJSON(props.sectionId, null, null, callBack());

          
          //     function callBack() {
          //        let int = props.updateFetch + 1;
          //         props.setUpdateFetch(int)
          //     }
          //     props.fetchJSON(props.sectionId, false, false, callBack)
      
     
          // }
         
        }
        apiCall('POST', api_url, dataJSON, responseTask)
        
        console.log('dataJSON', dataJSON, props.sectionId)
      }
  
      function handleStateMediaEditHeading(dimensionId, e, stateId, stateHeading) {
        console.log('handleStateMediaEditHeading', dimensionId, e, stateId);
        var fileList = e.target.files;
        var arrayLength = fileList.length;
        for (var i = 0; i < arrayLength; i++) {
          const api_url = Config.baseURLcms + 'componentdimension-stateimg-edit-heading/';
  
          props.setShowLoader(true);
          var formData = new FormData();
          formData.append('componentdimension', dimensionId);
          formData.append('state_id', stateId)
          // var stateHeading = document.getElementById("state_heading_" + stateId).value;
          // console.log('stateHeading', stateHeading)
          formData.append('state_heading', stateHeading)
          apiCall("POST", api_url, formData, null, null)
  
         
        }
      }
       
  function handleAddNewStateAnimation() {
    var animObj = {};
    animObj['duration'] = '';
    animObj['delay'] = '';
    animObj['ease'] = 'default';
    animObj['start'] = '';
    animObj['end'] = '';
    animObj['is_state'] = true;
    props.setNewStateAnimObj(animObj);
    props.setShowNewStateAnimObj(true);
   
    var newValueInputs = document.getElementsByClassName('newValueInput');
    console.log('newValueInputs', newValueInputs);
    var i;
    for (i = 0; i < newValueInputs.length; i++) {
      newValueInputs[i].value = "";
    }
    
  }

  function handleNewStateAnimValue(key, value) {
    if (Object.keys( props.newStateAnimObj).length > 0) {
      var animObj = Object.assign({},  props.newStateAnimObj);
    } else {
      var animObj = {};
    }
    animObj[key] = value;
    props.setNewStateAnimObj(animObj);
    console.log('handleNewStateAnimValue', animObj)
  }

  function onSetComponentDimensions(objId, newObj) {
    let newObjs = [ ...props.componentDimensions ];
    let objIndex = newObjs.findIndex(a => a.id === objId)
    newObjs[objIndex] = newObj
    props.setComponentDimensions(newObjs)
    console.log('newObjs', newObjs, newObj)
  }

  function hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  }


  function showStyleSelected(property, tempVal, obj) {
    let result;
    let objVal;
    let mixedResult;

    // console.log('showStyleSelected', property, tempVal, obj)

    if (selectionCss && selectionCss.hasOwnProperty(property)) {
      // console.log('showStyleSelected', property, selectionCss[property])
      if ((obj.html_text && obj.html_text.css && obj.html_text.css[property])) {
        if ((property === 'color')&&(/^#[0-9A-F]{6}$/i.test( obj.html_text.css[property]))) {
          // objVal = hexToRgb(obj.html_text.css[property])
          objVal = selectionCss[property]
          tempVal = objVal
        } else if (property === 'font-size') {
          // objVal = obj.html_text.css[property].toString() + 'px';
  
            objVal = selectionCss[property].toString() + 'px';
        } else {
          // objVal = obj.html_text.css[property];
          if (selectionCss) {
            // objVal = selectionCss[property]
            console.log('selectionCss', selectionCss, property)
          } else {
            objVal = obj.html_text.css[property];
          }
          
        }
        
      }
    } else {
      if (obj.html_text && obj.html_text.styleOverrides && obj.html_text.css[property]) {

        let propertyIndex = obj.html_text.styleOverrides.findIndex(a => a.css[property] !== obj.html_text.css[property])
        if (propertyIndex > -1) {
          mixedResult = true;
          objVal = 'mixed';
          // console.log('propertyIndex', propertyIndex, obj.html_text.styleOverrides[propertyIndex]['css'][property], obj.html_text.css[property])
        }
        
    
      }
    }

    if (tempVal && !objVal) {
      result = tempVal;
    } else {
      if (!mixedResult) {
        result = objVal;
      } else {
        result = "mixed"
      }
  
    }
    // if (result) {
    //   console.log('showStyleSelected result', result)
    // }

    return result;
  }

  function onShowLinkRow() {
    document.getElementById('linkRowGroup').classList.remove('plusRow');
    document.getElementById('linkRow').classList.remove('off');
    document.getElementById('linkPlus').classList.add('off');
    setInteraction(null);
  }

  function onReplaceFile(elemId, isBackground) {
    if (isBackground) {
      function handleBackground() {
        document.getElementById(elemId).click()
        props.setFormError(false)
      }
      let newError = {
        "heading": "Warning",
        "text": "You are about to change the background image for this page. This image will not be saved to other display formats.",
        "onBtn2Click": () => handleBackground(),
        "btn2Text": "Continue"
      };
      props.setFormError(newError)
    } else {
      document.getElementById(elemId).click()
    }
    
  }

  function onLinkAction(value, value_heading){
    buildComponentLink('action', value)
    setInteraction(value_heading)
  }

  function downloadFile(fileName) {
    // Need to update this with variable
    axios
    .get(Config.mediaURL + fileName, 
      { responseType: 'blob',
        headers: {}
      })
    .then((response) => {

      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      const url = window.URL.createObjectURL(blob);
      console.log('url', response)

      const link = document.createElement('a');
      link.href = url;
      link.download = fileName.replace('img/',''); 
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link); 

      window.URL.revokeObjectURL(url);
    })
    .catch((error) => {
      console.error('Error downloading the file:', error);
      alert('Failed to download the file.');
    });
  }

  function onUploadBtn(){
    document.querySelector('#uploadModal2').classList.toggle('on');
  }

  function getValue(field, value, fileFormat){



    let result = null;
    if ((props.multiSelectObjs && props.multiSelectObjs.length > 0) && fileFormat === 'grp'){
      let multiResult = null;
      props.multiSelectObjs.forEach((a, i) => {
        if (i === 0) {
          multiResult = a[field]
        } else {
           if (a[field] !== multiResult) {
            multiResult = 'mixed'
          }
        }
       
      })

      result = multiResult;
    } else {
      result = value;
    }


    return result
  }

  function handleFileName(obj){
    let heading;
     if (obj.file_format === "svg" && obj.svg_json.objects && obj.svg_json.objects.length > 0) {
        let svgObj = obj.svg_json.objects[0].type.toLowerCase();
        if (obj.svg_json.subtype) {
            svgObj = obj.svg_json.subtype.toLowerCase();
        }
        heading = fileNameType(obj.name, obj.layer_name, svgObj).map((obj2, j) => (<span key={"fileName_" + j + "-" + obj2.id}>{obj2}</span>))
      } else {
        heading = fileNameType(obj.name, obj.layer_name, obj.file_format)
      }
    return heading;
  }



    return(
        <div id="manifestColumn" className={((props.activeSettingId)?("settingsOn rightNav"):("settingsOff show"))}>
    
        <div className="settingsList">
        
        {props.componentDimensions
          .sort((a, b) => a.component_ordering < b.component_ordering ? 1 : -1)
          .filter(file => (file.id === props.activeSettingId))
          .map((dimension, i) => 
          (dimension) ?
           (<div
            key={'settingFile_' + i + "_" + updateSettings}
            >
              <div>
              <div id={"settings_" + dimension.id}>


                <div className={"mediaSettings showSettings on"}>

                  {dimension.background && <div className="settingsGroup"><div className="groupLabel">{"BACKGROUND"}</div>
                  
                   <div className="settingsRow">
                    

                    <div className="row row2">
                      <div className="row settingsGridFull">
                        <div className="canvasLabel">Type</div>
                        <div className="dropDownRow" id="settingsRow_type">
                          <div className="ui fontBtn" onClick={(e) => handleDropDown(e, 'type')}>{backgroundType} <ChevronDown className="icon" /></div>
                            <span className="inputField dropDownField" id={"inputField_type_" + dimension.id} onClick={(e) => handleDropDown(e, 'type')}>
                              <span className="dropDown">
                                <span className="dropDownChoices">

                                    <span className={"dropDownChoice ui"} onClick={() => setBackgroundType("Image")}>Image</span>
                                    <span className={"dropDownChoice ui"} onClick={() => setBackgroundType("Color")}>Color</span>


                                </span>
                              </span>
                            </span>
                        </div>
                    </div>
                     </div>

                  </div>

              <div className="settingsRow selectFileRow selectCanvasFile">

                
                  
                {backgroundType === 'Image' && <Fragment><h4>
                 
                  {(editField === "layer_name") ? 
                    <span className="inputField ui">
                      <input onKeyUp={(e) => handleKeyPress(e, "layer_name", null)} onChange={(e) => handleKeyChange(e, "layer_name", null)} type="text" autoComplete="off" defaultValue={dimension.layer_name?dimension.layer_name:stripImg(dimension.name)} name="layer_name" id="layer_name" />
                  </span> : 
                  <div onClick={() => onReplaceFile("fileReplace", dimension.background)} className="iconField fieldValue">{
                    handleFileName(dimension)


                    
                  }{(dimension.background) && <span className="caution"><Icons.Caution /></span>}</div>
                 
                 
                }
  
                </h4> 

                
                
                {!(dimension.file_format === "text") && <input style={{display: "none"}} type="file" id="fileReplace" accept={"image/png, image/jpeg, image/webp, video/mp4, video/quicktime, image/svg+xml"} onChange={(e) => handleMediaReplace(dimension.background, dimension.file_format, dimension.id, e, false)} multiple={false} />}
                
                {(editField === "layer_name") ? <span className="smCancel ui" onClick={() => setEditField(null)}><Icons.Cancel/></span> : <Icons.Pencil className="icon ui" onClick={() => setEditField("layer_name")} />}

              </Fragment>}

                
                 {dimension.background && backgroundType === "Color" && <div className="row settingsGrid">
                  <div className="canvasLabel ui" onClick={() => animColorPicker(animOpen, 'colorPicker3')}>Select Color</div>
           
                  <div className="ui colorChip" 
                  style={{
                    background: (dimension.background_color) ? (dimension.background_color) :"none"
                  }}
                  onClick={() => animColorPicker(animOpen, 'colorPicker3')}></div>
                  <span 
                  id="colorPicker3"
                  className="colorPicker"
                  >
                  <input type="hidden" id={"background_" + dimension.id} />
                  <SketchPicker
                    color={
                     tempColor ? tempColor : (dimension.background_color?dimension.background_color:"#ffffff")}
                    presetColors={["#A94B4B", "#A97E4B", "#A3A94B","#4BA950","#4BA98B","#4B97A9","#4B56A9","#804BA9","#A94BA3","#A94B74","#A6A6A6","#595959"]}
                    disableAlpha={true}
                    onChange={(color) => {
                      setTempColor(color.hex);
                      scheduleBackgroundUpdate(dimension.id, color.hex);
                    }}
                    onChangeComplete={(color, event) => {
                      let rawHex = color.hex;
                      if (event && event.target && event.target.value) {
                        rawHex = event.target.value;
                      }
                      scheduleBackgroundUpdate(dimension.id, rawHex);
                    }}
                />
                </span>
                       
                </div>}
  
                
  
              </div></div>}

               
                <div id="settingsScroll" className={"mediaSettingsInner" + ((dimension.is_locked && props.activeDisplay && (props.activeDisplay.id !== props.defaultDisplay))?" locked":"")}>
                
                {(!dimension.has_state_images && !dimension.background)?
                  (<div className="settingsGroup"> 
                  <div className="groupLabel">{
                   dimension.file_format === 'grp' ? "GROUP" : (dimension.background?"BACKGROUND IMAGE":"LAYER")
                  
                  }
                  
                  {dimension.image_path && <span onClick={() => downloadFile(dimension.name)}><Icons.Download className="icon ui" /></span>}
                  </div>

                  {dimension.background && !dimension.name && <div className="row settingsGrid">
                  <div className="canvasLabel ui" onClick={() => animColorPicker(animOpen, 'colorPicker3')}>Select Color</div>
           
                  <div className="ui colorChip" 
                  style={{
                    background: (dimension.background_color) ? (dimension.background_color) :"none"
                  }}
                  onClick={() => animColorPicker(animOpen, 'colorPicker3')}></div>
                  <span 
                  id="colorPicker3"
                  className="colorPicker"
                  >
                  <input type="hidden" id={"background_" + dimension.id} />
                  
                </span>
                       
                </div>}

                {(dimension.file_format === "statePNGButton") && <span className="canvasLabel"> Tab Button</span>}

                {!dimension.background && <div className="settingsRow selectFileRow selectCanvasFile">
                  
                      <h4>
                       
                        {(editField === "layer_name") ? 
                          <span className="inputField ui">
                            <input onKeyUp={(e) => handleKeyPress(e, "layer_name", null)} onChange={(e) => handleKeyChange(e, "layer_name", null)} type="text" autoComplete="off" defaultValue={dimension.layer_name?dimension.layer_name:stripImg(dimension.name)} name="layer_name" id="layer_name" />
                        </span> : 
                        <div onClick={() =>  (!["svg", "text", "grp", "popup"].includes(dimension.file_format)) && onUploadBtn()} className="iconField fieldValue">{
                        
                          handleFileName(dimension)
                        }{(dimension.background) && <span className="caution"><Icons.Caution /></span>}</div>
                        }
                      </h4>


                      <span className={'smModal'} id="uploadModal2">
                      <span className={'smModalChoice ui'} onClick={() => onReplaceFile("fileReplace", dimension.background)}><UploadIcon className="icon" /> Upload File</span>
                      <span className={'smModalChoice ui'} onClick={() => props.setShowAssetLibrary(dimension.id)}>
                        <Icons.PhotoLibrary className="icon" /> Select from Library</span>
                    </span>
                      
                      {!(dimension.file_format === "text") && <input style={{display: "none"}} type="file" id="fileReplace" accept={"image/png, image/jpeg, image/webp, video/mp4, video/quicktime, image/svg+xml"} onChange={(e) => handleMediaReplace(dimension.background, dimension.file_format, dimension.id, e, false)} multiple={false} />}
                      
                      {(editField === "layer_name") ? <span className="smCancel ui" onClick={() => setEditField(null)}><Icons.Cancel/></span> : <Icons.Pencil className="icon ui" onClick={() => setEditField("layer_name")} />}

                      

                    </div>}
                    {(dimension.file_format === "statePNGButton") ? 
                      (
                        <React.Fragment>
                          <span className="settingsRow selectFileRow">
                          <span className="canvasLabel">Active Tab Button</span>
                            

                            <div onClick={() => onReplaceFile("fileOnReplace")} className="iconField fieldValue ui">{dimension.name_on ? fileNameType(dimension.name_on, null).map((obj2, j) => (<span key={"fileName_" + j}>{obj2}</span>)):"Add File"}</div>

             
                            <input type="file" id="fileOnReplace" style={{display: "none"}} accept={"image/png, image/jpeg, image/webp, image/svg+xml"} onChange={(e) => handleMediaReplace(dimension.background, dimension.file_format, dimension.id, e, true)} multiple={false} />
                          
                          
                            </span>
                          <span className="settingsRow">
                          <span className="canvasLabel">Heading</span>
                            <input type="text" key={dimension.id + '_state_heading'} placeholder={dimension.component_state_heading} onChange={() => props.setUnSavedChanges(true)} id={'state_heading_' + dimension.id} />
                          </span>
                        </React.Fragment>
                      ) : ("")}

                      

                  </div>):("")}
                
                  {((props.section.states.length > 1)&&(dimension.file_format !== "statePNGButton"))?(
                    <div className={"settingsGroup stateGroup" + ((dimension.has_state_images) ? "":" plusRow")}>
                    {(dimension.has_state_images) ?
                    (
                      <span>


                      <div className="groupLabel">FILES</div>
                      {props.section.states.filter(s => s.id === props.activeStateId).map((state, k) => (
                      <span className="stateSettingsRow" id={"state_row_" + k} key={"state_" + k}>
                         <span className="settingsRow selectFileRow">
                      
                          {state.formats.filter((obj0) => obj0.display_id === props.aspectRatio).map((obj, l) => (
                           
                           (state.layer_name && <span className="fileNameGroup" key={"state_format_" + l}>
                              <span className="stateRow canvasLabel"></span>
                              <span className="fileName">{state.layer_name}</span>
                            </span>)
                      
                          ))}
                          
                          {(!state.first) ? (
                            <span>
              
                            {dimension.componentdimensionstateimages.map((obj1, m) => (
                          
                              (obj1.state_id === String(state.id)) ? (
                                <span className="fileNameGroup" key={"state_format_image_" + m}>
                                  <span className="fileName">{stripImg(obj1.name)}</span>

                        

                                </span>
                                ) : ("")
                            ))}
                         
                            <input type="file" id={"fileReplace_state_" + state.id} accept={"image/png, image/jpeg, image/webp, video/mp4, video/webm"} data-stateid={state.id} onChange={(e) => handleStateMediaAddReplace(dimension.id, e, state.id, state.state_heading)} multiple={false} />

                            </span>
                            ) : (
                              <div className="fileNameGroup">
                                

                                <div onClick={() => onReplaceFile('fileReplace')} className="iconField fieldValue">{fileNameType(dimension.name, null).map((obj2, j) => (<span key={"fileName_" + j}>{obj2}</span>))}</div>


                                <input type="file" style={{display: "none"}} id="fileReplace" accept={"image/png, image/jpeg, image/webp"} onChange={(e) => handleMediaReplace(dimension.background, dimension.file_format, dimension.id, e, false)} multiple={false} />
                              </div>
                            )}
                        </span>
                        
                            
                      </span>

                      ))}
                      </span>
                      ):
                      (
                 
                        <Fragment>

                        <div className="groupLabel"><p>STATE IMAGES</p> </div>
                         <span className="plus ui" onClick={() => handleShowStateOptions(dimension.id)}><Icons.Plus className="icon" /></span>
                        </Fragment>
                      
                      )
                      }
                      </div>
                  ):("")}

                  {!dimension.background  && <div className={"settingsGroup" + ((dimension.is_locked && props.activeDisplay && (props.activeDisplay.id !== props.defaultDisplay))?" locked":"")}>
                      <div className="groupLabel"><p>DISPLAY HANDLING</p></div>
                      <div className="settingsRow">
                      <div className={"ui" + ((dimension.is_locked) ? " on" : " off")}>
                      
                      <span onClick={() => handleAspectLock(dimension.id)}>
                        {(dimension.is_locked)?(
                          <span className="formatLock ui">

                            <span className="btn1 autoWidth on">Automatic</span>
                            <span className="btn1 autoWidth">Manual</span>
                          </span>
                          ):
                          (
                            <span className="formatLock ui">
                              <span className="btn1 autoWidth">Automatic</span>
                            <span className="btn1 autoWidth on">Manual</span>
                            </span>
                          )}
                        
                      </span>
                      
                      </div>
                    </div>
                  </div>}

                  {!dimension.background && dimension.file_format === "vid" && <div className={"settingsGroup" + ((dimension.is_locked && props.activeDisplay && (props.activeDisplay.id !== props.defaultDisplay))?" locked":"")}>
                  <div className="groupLabel"><p>Video Handling</p></div>
                  <div className="settingsRow">
                  <div className={"ui" + ((dimension.is_locked) ? " on" : " off")}>
                  
                  <span>
                  <span className="formatLock ui">
                  <span 
                  onClick={(e) => updateDimension(e, dimension.id, 'autoplay', true)}
                  className={
                      classNames(
                        "btn1", 
                        "autoWidth",
                        dimension.autoplay && "on"
                      )
                    }>Autoplay</span>
                    <span 
                    onClick={(e) => updateDimension(e, dimension.id, 'autoplay', false)}
                    className={
                      classNames(
                        "btn1", 
                        "autoWidth",
                        !dimension.autoplay && "on"
                      )
                    }>Interactive</span>
                </span>
                  </span>
                  
                  </div>
                 </div>
                 <div className="settingsRow">
                  <div className={"ui" + ((dimension.is_locked) ? " on" : " off")}>
                  
                  <span>
                  <span className="formatLock ui">
                  <span 
                  onClick={(e) => updateDimension(e, dimension.id, 'loop', true)}
                  className={
                      classNames(
                        "btn1", 
                        "autoWidth",
                        dimension.loop && "on"
                      )
                    }>Loop</span>
                    <span 
                    onClick={(e) => updateDimension(e, dimension.id, 'loop', false)}
                    className={
                      classNames(
                        "btn1", 
                        "autoWidth",
                        !dimension.loop && "on"
                      )
                    }>Play Once</span>
                </span>
                  </span>
                  
                  </div>
                 </div>
              </div>}

                  {!dimension.background  && <div className="settingsGroup"> 
                    <div className="groupLabel"><p>Layout</p></div>
                    {dimension.file_format !== 'popup' && <div className="settingsRowIcon">
                      <div className="settingsRow halfRow"><span className="canvasLabel">Width <span className="canvasHelp">(px)</span></span> 
                        
                        <input disabled={dimension.file_format === "svg"} type={"number"} min="0" className="valueInput" onClick={(e) => handleInputFocus(e)} key={dimension.width + '_width_' + props.versionNumber} onChange={(e) => delayUpdateDimension(e, dimension.id, 'width', dimension.width, dimension.height)} placeholder={getValue('width', dimension.width, dimension.file_format)} defaultValue={getValue('width', dimension.width, dimension.file_format)} id={'width_dim_' + dimension.id} />

                      </div>
                      <span className="iconField ui" onClick={() => props.setLockAr(!props.lockAr)}>{props.lockAr ? <Icons.Lock className="icon" /> : <Icons.LockOpen className="icon" />}</span>
                      <div className="settingsRow halfRow rightRow">
                        <span className="canvasLabel">Height <span className="canvasHelp">(px)</span></span>
                        
                        <input  disabled={dimension.file_format === "svg"} type="number" min="0" className="valueInput" onClick={(e) => handleInputFocus(e)} key={dimension.height + props.versionNumber} onChange={(e) => delayUpdateDimension(e, dimension.id,"height", dimension.width, dimension.height)} placeholder={getValue('height', dimension.height, dimension.file_format)} defaultValue={getValue('height', dimension.height, dimension.file_format)} id={'height_dim_' + dimension.id} />

                      </div>
                    </div>}
                    <div className="settingsRow halfRow">
                      <span className="canvasLabel">Left <span className="canvasHelp">(px)</span></span>

                      <input disabled={dimension.file_format === "svg"} type="number" min="0" className="valueInput" onClick={(e) => handleInputFocus(e)} key={dimension.id + '_x_pos_' + props.versionNumber} onChange={(e) => delayUpdateDimension(e, dimension.id, 'x_pos')} onKeyUp={() => props.setUnSavedChanges(true)} placeholder={getValue('x_pos', dimension.x_pos, dimension.file_format)} id={'x_pos_dim_' + dimension.id} />

                    </div> 
                    <div className="settingsRow halfRow rightRow">
                      <span className="canvasLabel">Top <span className="canvasHelp">(px)</span></span>

                      <input  disabled={dimension.file_format === "svg"} type="number" min="0" className="valueInput" onClick={(e) => handleInputFocus(e)} key={dimension.id + '_y_pos' + props.versionNumber} onChange={(e) => delayUpdateDimension(e, dimension.id, 'y_pos')} onKeyUp={() => props.setUnSavedChanges(true)} placeholder={getValue('y_pos', dimension.y_pos, dimension.file_format)}  id={'y_pos_dim_' + dimension.id} />

                    </div>
                    {(props.multiSelectIds.length > 1) ? <div className="settingsRow">
                      <span className="canvasLabel">Align</span>
                      <div className="settingsRow grid6">
                        <div className="ui iconField" onClick={() => handleMultiSelect('align', 'left', props.componentDimensions, props.multiSelectIds, props.setComponentDimensions, props.setUnSavedChanges)}><Icons.AlignHoriLeft className="icon" /></div>
                        <div className="ui iconField" onClick={() => handleMultiSelect('align', 'center_w', props.componentDimensions, props.multiSelectIds, props.setComponentDimensions, props.setUnSavedChanges)}><Icons.AlignHoriCenter className="icon" /></div>
                        <div className="ui iconField" onClick={() => handleMultiSelect('align', 'right', props.componentDimensions, props.multiSelectIds, props.setComponentDimensions, props.setUnSavedChanges)}><Icons.AlignHoriRight className="icon" /></div>
                        <div className="ui iconField" onClick={() => handleMultiSelect('align', 'top', props.componentDimensions, props.multiSelectIds, props.setComponentDimensions, props.setUnSavedChanges)}><Icons.AlignVertTop className="icon" /></div>
                        <div className="ui iconField" onClick={() => handleMultiSelect('align', 'center_v', props.componentDimensions, props.multiSelectIds, props.setComponentDimensions, props.setUnSavedChanges)}><Icons.AlignVertCenter className="icon" /></div>
                        <div className="ui iconField" onClick={() => handleMultiSelect('align', 'bottom', props.componentDimensions, props.multiSelectIds, props.setComponentDimensions, props.setUnSavedChanges)}><Icons.AlignVertBottom className="icon" /></div>
                      </div>
                    </div> : <div className="settingsRow">
                    <span className="canvasLabel">Align</span>
                    <div className="settingsRow grid6">
                      <div className="ui iconField" onClick={() => handleAlignSelect('left', dimension.id)}><Icons.AlignHoriLeft className="icon" /></div>
                      <div className="ui iconField" onClick={() => handleAlignSelect('center_w', dimension.id)}><Icons.AlignHoriCenter className="icon" /></div>
                      <div className="ui iconField" onClick={() => handleAlignSelect('right', dimension.id)}><Icons.AlignHoriRight className="icon" /></div>
                      <div className="ui iconField" onClick={() => handleAlignSelect('top',dimension.id)}><Icons.AlignVertTop className="icon" /></div>
                      <div className="ui iconField" onClick={() => handleAlignSelect('center_v', dimension.id)}><Icons.AlignVertCenter className="icon" /></div>
                      <div className="ui iconField" onClick={() => handleAlignSelect('bottom', dimension.id)}><Icons.AlignVertBottom className="icon" /></div>
                    </div>
                  </div>}
            
                      
                  <div className="settingsRow halfRow">
                    <span className="canvasLabel">Opacity (%)</span>

                    <input type="number" min="0" max="100" className="valueInput" onClick={(e) => handleInputFocus(e)} key={dimension.id + '_opacity_' + props.versionNumber} onChange={(e) => delayUpdateDimension(e, dimension.id, 'opacity')} onKeyUp={() => props.setUnSavedChanges(true)} placeholder={getValue('opacity', dimension.opacity, dimension.file_format)} id={'opacity_dim_' + dimension.id} />

                  </div> 

                   <div className="settingsRow halfRow">
                    <span className="canvasLabel">Rotation (°)</span>

                    <input type="number" min="0" max="360" className="valueInput" onClick={(e) => handleInputFocus(e)} key={dimension.id + '_opacity_' + props.versionNumber} onChange={(e) => delayUpdateDimension(e, dimension.id, 'rotation')} onKeyUp={() => props.setUnSavedChanges(true)} placeholder={getValue('rotation', dimension.rotation, dimension.file_format)} id={'rotation_dim_' + dimension.id} />

                  </div> 
           
                      
                  </div>}
                  
                  {(dimension.background && (props.multiSelectIds.length > 1)) && <div className="settingsGroup"><div className="settingsRow">
                  <span className="canvasLabel">Align</span>
                  <div className="settingsRow grid6">
                    <div className="ui iconField" onClick={() => handleMultiSelect('align', 'left', props.componentDimensions, props.multiSelectIds, props.setComponentDimensions)}><Icons.AlignHoriLeft className="icon" /></div>
                    <div className="ui iconField" onClick={() => handleMultiSelect('align', 'center_w', props.componentDimensions, props.multiSelectIds, props.setComponentDimensions)}><Icons.AlignHoriCenter className="icon" /></div>
                    <div className="ui iconField" onClick={() => handleMultiSelect('align', 'right', props.componentDimensions, props.multiSelectIds, props.setComponentDimensions)}><Icons.AlignHoriRight className="icon" /></div>
                    <div className="ui iconField" onClick={() => handleMultiSelect('align', 'top', props.componentDimensions, props.multiSelectIds, props.setComponentDimensions)}><Icons.AlignVertTop className="icon" /></div>
                    <div className="ui iconField" onClick={() => handleMultiSelect('align', 'center_v', props.componentDimensions, props.multiSelectIds, props.setComponentDimensions)}><Icons.AlignVertCenter className="icon" /></div>
                    <div className="ui iconField" onClick={() => handleMultiSelect('align', 'bottom', props.componentDimensions, props.multiSelectIds, props.setComponentDimensions)}><Icons.AlignVertBottom className="icon" /></div>
                  </div>
                  
        

                </div></div>}
                


                  {(dimension.file_format === "svg") && (
                    <Fragment>
                    {dimension.svg_json && dimension.svg_json.subtype !== 'line' && <div className="settingsGroup">
                      <div className="groupLabel"><p>Color</p></div>
                      <div className="settingsRow">
                        <div className="row settingsGrid">
                        <div className="canvasLabel ui" onClick={() => animColorPicker(animOpen, 'colorPicker2')}>Fill</div>
              
                        <div className="ui colorChip" 
                        style={{
                          background: (dimension.svg_json && dimension.svg_json.objects && dimension.svg_json.objects[0]['fill']) ? dimension.svg_json.objects[0]['fill'] :"none"
                        }}
                        onClick={() => animColorPicker(animOpen, 'colorPicker2')}></div>
                          <span id="colorPicker2"
                          className="colorPicker">
                            <SketchPicker
                            presetColors={["#A94B4B", "#A97E4B", "#A3A94B","#4BA950","#4BA98B","#4B97A9","#4B56A9","#804BA9","#A94BA3","#A94B74","#A6A6A6","#595959"]}
                              color={ tempColor ? tempColor : ((dimension.svg_json && dimension.svg_json.objects && dimension.svg_json.objects[0]['fill'])?dimension.svg_json.objects[0]['fill'] :"")}
                              onChange={(color) => {
                                setTempColor(color.hex)
                                updateSVG('fill', color.hex)
                              }}
                              onChangeComplete={(color, event) => {

                                let rawHex = color.hex;
                                if (event && event.target && event.target.value) {
                                  rawHex = event.target.value;
                                }
                                updateSVG('fill', rawHex);
                                // tempColor ? updateSVG('fill', tempColor) : updateSVG('fill', color.hex)
                              }}
                            />
                            
                          </span>
                          <span className="canvasLabel ui" onClick={() =>  updateSVG('fill', null)}>Clear</span>
                    </div>

                      </div>
                  </div>}
                  <div className="settingsGroup">
                      <div className="groupLabel"><p>Stroke</p></div>
                      <div className="settingsRow">
                        <div className="row settingsGrid">
                          <div className="canvasLabel ui" onClick={() => animColorPicker(animOpen, 'colorPicker3')}>Color</div>
              
                          <div className="ui colorChip" 
                          style={{
                          background: (dimension.svg_json && dimension.svg_json.objects && dimension.svg_json.objects[0]['stroke']) ? dimension.svg_json.objects[0]['stroke'] :"none"
                        }}
                          onClick={() => animColorPicker(animOpen, 'colorPicker3')}></div>
                          <span id="colorPicker3" className="colorPicker">
                            <SketchPicker
                            presetColors={["#A94B4B", "#A97E4B", "#A3A94B","#4BA950","#4BA98B","#4B97A9","#4B56A9","#804BA9","#A94BA3","#A94B74","#A6A6A6","#595959"]}
                              color={ tempColor ? tempColor : ((dimension.svg_json && dimension.svg_json.objects && dimension.svg_json.objects[0]['stroke'])?dimension.svg_json.objects[0]['stroke'] :"")}
                              onChange={(color) => {
                                setTempColor(color.hex)
                                updateSVG('stroke', color.hex)
                              }}
                              onChangeComplete={(color, event) => {
                                //  tempColor ? updateSVG('stroke', tempColor) : updateSVG('stroke', color.hex)                          
                                let rawHex = color.hex;
                                if (event && event.target && event.target.value) {
                                  rawHex = event.target.value;
                                }
                                updateSVG('stroke', rawHex);

                              }}
                              
                            />

                            
                           
                          </span>
                             <span className="canvasLabel ui" onClick={() =>  updateSVG('stroke', null)}>Clear</span> 
                        </div>
                      </div>
                      <div className="settingsRow">
                        <div className="row settingsGrid">
                          <div className="canvasLabel ui">Width <span className="canvasHelp">(px)</span></div>
                          <input type="number" min="0" className="valueInput" onClick={(e) => handleInputFocus(e)} key={dimension.id + '_svg_strokeWidth_' + props.versionNumber} onChange={(e) => delayUpdateSVG('strokeWidth', e.target.value)} onKeyUp={() => props.setUnSavedChanges(true)} placeholder={dimension.svg_json.objects[0]['strokeWidth']} id={'svg_strokeWidth_' + dimension.id} />  
                          
                        </div>
                      </div>
                  </div>
                  </Fragment>
                  )}


                  {/* POPUP HANDLING */}
                   {(dimension.file_format === "popup") && (
                    <Fragment>
                    
                  <div className="settingsGroup">
                     <div className="groupLabel"><p>POPUP TEXT</p></div>
                      <div className="settingsRow">
                        <div className="canvasLabel ui">Text</div>
                        <textarea onKeyUp={(e) => handleKeyPress(e, "html_text", null)} onChange={(e) => handleKeyChange(e, "html_text", null)} autoComplete="off" key={dimension.id + "_html_text"} defaultValue={dimension.html_text} name="html_text" className="textBlock" id="html_text" maxLength={280} />
                      </div>
                      <div className="settingsRow">
                        <div className="row settingsGrid">
                           <div className="settingsRow halfRow" id="settingsRow_popUpPos" onClick={(e) => handleDropDown(e, 'popUpPos')}>
                           <div className="canvasLabel ui">Placement</div>
                            <div className="ui fontBtn">
                          
                            <input type="text" className="spanInput" id={"inputField_popUpPos_text_" + dimension.id} onClick={(e) => handleDropDown(e, 'popUpPos')} defaultValue={dimension.popup_pos} key={dimension.popup_pos + "_" +  + props.versionNumber}  /> 
                              
                            </div>
                            <span className="inputField dropDownField ui" id={"inputField_popUpPos_" + dimension.id}>
                              <span className="dropDown">
                                <span className="dropDownChoices">
                                  {Config.popupPlaces.map((obj, i) => (
                                    <span key={'popupPlaces_'+i} className={"dropDownChoice ui"} onClick={(e) => updateDimension(e, dimension.id, 'popup_pos', obj)}>{obj}</span>
                                  ))}
                                </span>
                              </span>
                            </span> 
                            </div>
                        </div>
                      </div>
                      
                  </div>
                  </Fragment>
                  )}
                    
                  {/* TEXT HANDLING */}
                  {(dimension.file_format === "text") && (
                    <Fragment>
                    <div className="settingsGroup">
                      <div className="groupLabel"><p>TEXT</p></div>

                      <div className="settingsRow" id="settingsRow_fontFamily">
                      <div className="ui fontBtn" onClick={(e) => handleDropDown(e, 'fontFamily')}>{getSelectedValue(dimension, 'font-family', "Font Family")}</div>
                        <span className="inputField dropDownField" id={"inputField_fontFamily_" + dimension.id}>
                          <span className="dropDown">
                            <span className="dropDownChoices">
                              {Config.fontFamilies.map((obj, i) => (
                                <span key={'fontfamily_'+i} className={"dropDownChoice ui"} onClick={() => updateText('font-family', obj)}>{obj}</span>
                              ))}
                            </span>
                          </span>
                        </span>
                      </div>
                      
                      
                      <div className={"settingsRow halfRow"} id="settingsRow_fontWeight">
                      <div className="ui fontBtn" onClick={(e) => handleDropDown(e, 'fontWeight')}>{getSelectedValue(dimension, 'font-weight', "Font Weight")}</div>
                      <span className="inputField dropDownField" id={"inputField_fontWeight_" + dimension.id}>
                        <span className="dropDown">
                          <span className="dropDownChoices">
                            <span className={"dropDownChoice ui"} onClick={() => updateText('font-weight', '200')}>Light</span>
                            <span className={"dropDownChoice ui"} onClick={() => updateText('font-weight', 'regular')}>Regular</span>
                            <span className={"dropDownChoice ui"} onClick={() => updateText('font-weight', 'bold')}>Bold</span>
                          </span>
                        </span>
                      
                      </span> 
                    
                      
                      </div>
                    

                      <div className="settingsRow halfRow" id="settingsRow_fontSize" onClick={(e) => handleDropDown(e, 'fontSize')}>
                        <div className="ui fontBtn">

                        <input type="text" className="spanInput" id={"inputField_fontSize_text_" + dimension.id} onClick={(e) => handleDropDown(e, 'fontSize')} defaultValue={getSelectedValue(dimension, 'font-size', 32)} key={dimension.html_text + "_" +  + props.versionNumber} onChange={(e) => updateText('font-size', e.target.value)} /> 
                          
                        </div>
                        <span className="inputField dropDownField ui" id={"inputField_fontSize_" + dimension.id}>
                          <span className="dropDown">
                            <span className="dropDownChoices">
                              {Config.fontSizes.map((obj, i) => (
                                <span key={'fontsize_'+i} className={"dropDownChoice ui"} onClick={() => updateText('font-size', obj)}>{obj}</span>
                              ))}
                            </span>
                          </span>
                        </span> 
                        </div>
                    

                 
                        <div className="settingsRow grid3">
                          <div className="ui iconField" onClick={() => updateText('text-align', 'left')}><Icons.AlignLeft className="icon" /></div>
                          <div className="ui iconField" onClick={() => updateText('text-align', 'center')}><Icons.AlignCenter className="icon" /></div>
                          <div className="ui iconField" onClick={() => updateText('text-align', 'right')}><Icons.AlignRight className="icon" /></div>
                        </div>
                      
                        <div className="settingsRow">
                            <div className="settingsRow halfRow iconTextRow">
                              <Icons.LineHeight className="icon" />
                              <input type="text" className="valueInput sm" onClick={(e) => handleInputFocus(e)} key={dimension.id + '_lineheight'} onKeyUp={(e) => delayedUpdateText('line-height', e.target.value)} defaultValue={dimension.html_text && dimension.html_text['css'] && dimension.html_text.css['line-height'] ? dimension.html_text.css['line-height'] : "normal"} id={'lineheight_' + dimension.id} />
                            </div>
                            <div className="settingsRow halfRow iconTextRow">
                              <Icons.LetterSpacing className="icon" />
                              <input type="text" className="valueInput sm" onClick={(e) => handleInputFocus(e)} key={dimension.id + '_letterspacing'} onKeyUp={(e) => delayedUpdateText('letter-spacing', e.target.value)} defaultValue={dimension.html_text && dimension.html_text['css'] && dimension.html_text.css['letter-spacing'] ? dimension.html_text.css['letter-spacing'] : ('auto')} id={'letterspacing_' + dimension.id} />
                            </div>
                        </div>
                        

                        

                    

                    </div>

                    <div className="settingsGroup">
                    <div className="groupLabel"><p>COLOR</p></div>
                    <div className="row settingsGrid">
                    <div className="canvasLabel ui" onClick={() => animColorPicker(animOpen, 'colorPicker0')}>Fill</div>
          
                    <div className="ui colorChip" 
                    style={{
                      background: tempColor ? tempColor : showStyleSelected('color', (dimension.html_text && dimension.html_text.css && dimension.html_text.css['color'])?dimension.html_text.css['color'] :"", dimension)
                    }}
                    onClick={() => !tempColor ? animColorPicker(animOpen, 'colorPicker0') : updateText('color', tempColor)}></div>
                      <span id="colorPicker0"
                      className="colorPicker">
                        <SketchPicker
                        colors={["#A94B4B", "#A97E4B", "#A3A94B","#4BA950","#4BA98B","#4B97A9","#4B56A9","#804BA9","#A94BA3","#A94B74","#A6A6A6","#595959"]}
                        color={ tempColor ? tempColor : (dimension.html_text && dimension.html_text.css && dimension.html_text.css['color'])?dimension.html_text.css['color'] :""}
                        disableAlpha={true}
                        onChange={(color) => {
                          setTempColor(color.hex)
                          // console.log('onChange, tempColor', color.hex, tempColor)
                        }}
                        onChangeComplete={
                          (color, event) => {
                            if (color && !tempColor) {
                              let rawHex = color.hex;
                              if (event && event.target && event.target.value) {
                                rawHex = event.target.value;
                              }
                              updateText('color', rawHex)
                              console.log('onChangeComplete', tempColor, color.hex)
                            }
                          }
                        }
                        // onChangeComplete={(color, event) => {
                        //   if (color && !tempColor) {
                        //     updateText('color', color.hex)
                        //     console.log('onChangeComplete', tempColor, color.hex)
                        //   } else if (tempColor) {
                        //     updateText('color', tempColor)
                        //     console.log('onChangeComplete', tempColor, color.hex)
                        //   } else {
                        //     console.log('onChangeComplete: color not found')
                        //   }
                          
                         
                        // }}

                        />
                      </span>
                </div>
                    </div>
                    </Fragment>
                  )}
                  



                  {(!dimension.background && !dimension.has_state_images) && <div className={"settingsGroup" + ((!dimension.typeName || dimension.typeName === 'parallax')?" plusRow":"")} id="publicAnim">
                    
                  {/* Animation Starts */}
                    <div className="groupLabel"><p>ANIMATION</p> </div>
                    {(!dimension.typeName || dimension.typeName === 'parallax')  && <span className="plus ui" onClick={() => handleAnimChoice('page', dimension.id)}><Icons.Plus className="icon" /></span>}
                    {(dimension.typeName && dimension.typeName === 'page') && 
                    <React.Fragment>
                     
                    {<React.Fragment>
                    <ul className="dropDown">
                      <li>
                        <span className="dropDownBtn" onClick={() => setShowAnimPresetDropDown(current => !current)}>

                          <span className="dropDownValue">Select Animation</span>
       
                            <Icons.ChevronDown className="icon" id="downArrow" transform={(showAnimPresetDropDown)?('scale(1,-1) translate(0,2)'):""}  />
                          </span>

                        <ul className={"mediaDropDown " + ((showAnimPresetDropDown) ? ('on') : ('off'))}>
                          {props.animationPresets && props.animationPresets.filter((obj) => obj.animation_type === dimension.typeName).map((item, i) => 
                            <li className="animSelect" key={'animPreset_' + i} onClick={() => runAnimPreset(item, dimension.id, dimension.is_locked, dimension.display_name, dimension.partner_ids, false)}><span>{item.name}</span></li>
                         ) }

                        </ul>
                      </li>
                    </ul>
                    </React.Fragment>}

            

                    {(dimension.animations.map((anim, i) => 
                      
                      <div className="animObj" key={"anim_" + dimension.id + i}>
                        {anim.property && <div className="settingsRow">
                          <div className="animLabel">{anim.property} Animation <span className="clearValue" onDoubleClick={(e) => handleDeleteAnim(anim.id)}>&#215;</span></div>
                        </div>}

                        {/* No Anim Set Yet */}
                        {!anim.property && <div className="animRow">
                        <div className="settingsRow">
                        <div className="canvasLabel">Animation Property</div>
                       
                        </div>

                        <div className="settingsRow">
                        { AnimationProperties.map((item, i) => 
                          <div key={'property_' + i} className={"animBtn" + ((anim.property === item.slug) ? (' on') : (''))} onClick={(e) => handleAnimValue(dimension.id, anim.id, 'property', item.slug, e)}>{item.name}</div>
                        )}
                       </div>
                        </div>
                      }

                      {/* Anim Properties */}
                        <div className="animRow">
                          <div>                                
                            <div className="settingsRow halfRow">
                              <span className="canvasLabel">Start</span>
                              <input type="text" defaultValue={anim.start} key={anim.start + anim.id} id={"inputValue_start_" + anim.id} className="valueInput" autoComplete="off" onClick={(e) => handleInputFocus(e)} onKeyUp={(e) => handleAnimValue(dimension.id, anim.id, 'start', e.target.value, e)} />
                             
                            </div>

                            <div className="settingsRow halfRow rightRow">
                              <span className="canvasLabel">End</span>
                              <input type="text" placeholder={anim.end} id={"inputValue_end_" + anim.id} className="valueInput" onClick={(e) => handleInputFocus(e)} onKeyUp={(e) => handleAnimValue(dimension.id, anim.id, 'end', e.target.value, e)} />
                            </div>
                            
                            <ul className={"dropDown mediaDropDown inputDropDown off"} id={"inputValue_start_" + anim.id + '_dd'}>
                            
                            {(anim.property === 'opacity') && (Config.opacityChoices.map((item, i) => 
                              <li className="animSelect" key={"startSelect_"+ i}><span onClick={(e) => handleDropDownValue(e, item, "inputValue_start_" + anim.id, "inputValue_start_" + anim.id + '_dd', dimension.id, anim.id, 'start')}>{item}</span></li>
                            ))}

                            {(anim.property === 'scale') && (Config.scaleChoices.map((item, i) => 
                              <li className="animSelect" key={"startSelect_"+ i}><span onClick={(e) => handleDropDownValue(e, item, "inputValue_start_" + anim.id, "inputValue_start_" + anim.id + '_dd', dimension.id, anim.id, 'start')}>{item}</span></li>
                            ))}

                            {(anim.property === 'translateX') && (Config.xPosChoices.map((item, i) => 
                              <li className="animSelect" key={"startSelect_"+ i}><span onClick={(e) => handleDropDownValue(e, item, "inputValue_start_" + anim.id, "inputValue_start_" + anim.id + '_dd', dimension.id, anim.id, 'start')}>{item}</span></li>
                            ))}

                            {(anim.property === 'translateY') && (Config.yPosChoices.map((item, i) => 
                              <li className="animSelect" key={"startSelect_"+ i}><span onClick={(e) => handleDropDownValue(e, item, "inputValue_start_" + anim.id, "inputValue_start_" + anim.id + '_dd', dimension.id, anim.id, 'start')}>{item}</span></li>
                            ))}

                            </ul>

                            <ul className={"dropDown mediaDropDown inputDropDown off"} id={"inputValue_end_" + anim.id + '_dd'}>
                            {(anim.property === 'opacity') &&(Config.opacityChoices.map((item, i) => 
                              <li className="animSelect" key={"endSelect_"+ i}><span onClick={(e) => handleDropDownValue(e, item, "inputValue_end_" + anim.id, "inputValue_end_" + anim.id + '_dd', dimension.id, anim.id, 'end')}>{item}</span></li>
                            ))}
                            {(anim.property === 'scale') &&(Config.scaleChoices.map((item, i) => 
                              <li className="animSelect" key={"endSelect_"+ i}><span onClick={(e) => handleDropDownValue(e, item, "inputValue_end_" + anim.id, "inputValue_end_" + anim.id + '_dd', dimension.id, anim.id, 'end')}>{item}</span></li>
                            ))}
                            {(anim.property === 'translateX') &&(Config.xPosChoices.map((item, i) => 
                              <li className="animSelect" key={"endSelect_"+ i}><span onClick={(e) => handleDropDownValue(e, item, "inputValue_end_" + anim.id, "inputValue_end_" + anim.id + '_dd', dimension.id, anim.id, 'end')}>{item}</span></li>
                            ))}
                            {(anim.property === 'translateY') &&(Config.yPosChoices.map((item, i) => 
                              <li className="animSelect" key={"endSelect_"+ i}><span onClick={(e) => handleDropDownValue(e, item, "inputValue_end_" + anim.id, "inputValue_end_" + anim.id + '_dd', dimension.id, anim.id, 'end')}>{item}</span></li>
                            ))}
                              
                            </ul>

                          </div>
                          

                          {(dimension.typeName === 'page') && (<React.Fragment>

                          <div className="settingsRow halfRow">
                            <span className="canvasLabel">Duration</span>
                            <input type="number" defaultValue={anim.duration} key={anim.duration + anim.id} id={"inputValue_duration_" + anim.id} className="valueInput" min="0" onClick={(e) => handleInputFocus(e)} onKeyUp={(e) => handleAnimValue(dimension.id, anim.id, 'duration', e.target.value, e)} step="0.01" />
                          </div>

                          <div className="settingsRow halfRow rightRow">
                            <span className="canvasLabel">Delay</span>
                            <input type="number" defaultValue={anim.delay} key={anim.delay + anim.id} id={"inputValue_delay_" + anim.id} className="valueInput" min="0" onClick={(e) => handleInputFocus(e)} onKeyUp={(e) => handleAnimValue(dimension.id, anim.id, 'delay', e.target.value, e)} step="0.01" />
                          </div>

                          <ul className={"dropDown mediaDropDown inputDropDown off"} id={"inputValue_duration_" + anim.id + '_dd'}>
                            {(Config.durationChoices.map((item, i) => 
                              <li className="animSelect" key={"durationSelect_"+ i}><span onClick={(e) => handleDropDownValue(e, item, "inputValue_duration_" + anim.id, "inputValue_duration_" + anim.id + '_dd', dimension.id, anim.id, "duration")}>{item}</span></li>
                            ))}
                            </ul>

                          <ul className={"dropDown mediaDropDown inputDropDown off"} id={"inputValue_delay_" + anim.id + '_dd'}>
                            {(Config.delayChoices.map((item, i) => 
                              <li className="animSelect" key={"delaySelect_"+ i}><span onClick={(e) => handleDropDownValue(e, item, "inputValue_delay_" + anim.id, "inputValue_delay_" + anim.id + '_dd', dimension.id, anim.id, "delay")}>{item}</span></li>
                            ))}
                            </ul>
                        
                          </React.Fragment>)}

                      <div className="settingsRow easeRow">
                      <span className="canvasLabel">Ease</span>
                        {Config.EasingProperties.map((item, i) => <div key={'easing_' + i} className={"animBtn" + ((anim.ease === item.slug) ? (' on') : (''))} onClick={(e) => handleAnimValue(dimension.id, anim.id, 'ease', item.slug, e)}>{item.name}</div> )}
                      </div>
                    </div>
                  </div>

                    ))}
                    </React.Fragment>}


                  </div>}
                  
                   {/* ANIMATION Ends */}

                   {/* INTERACTION Starts */}
                   {!dimension.background && (dimension.file_format === "img") &&  <div className={classNames("settingsGroup",
                    (dimension.file_format === "statePNGButton") && "off",
                    !dimension.component_link && "plusRow"
                   )} id="linkRowGroup"> 
                   <div className="groupLabel"><p>Interaction</p></div>
 
                       {(!dimension.component_link ) && <span className="plus ui" id="linkPlus" onClick={() => onShowLinkRow()}><Icons.Plus className="icon" /></span> }




                        
                       <span className={classNames("settingsRow",
                            !dimension.component_link && "off"
                          )} id="linkRow">


                      

                          <div id="settingsRow_linkAction">
                          <span className="canvasLabel">Action</span>
                          
                          {(dimension.component_link || interaction) ? <div className="ui linkAction dropDownBtn selectionLocked">
   
                           {(dimension.component_link || interaction) ? (
                            interaction ? interaction : dimension.component_link
                          ) : "Select Action"}
                          
                      
                          <span className="clearValue" onDoubleClick={(e) => removeLink(dimension.id)}>&#215;</span>
                           
                           </div> : <div className="ui linkAction dropDownBtn" onClick={(e) => handleDropDown(e, 'linkAction')}>
   
                           {(dimension.component_link || interaction) ? (
                            interaction ? interaction : dimension.component_link
                          ) : "Select Action"}
                          
                          <Icons.ChevronDown className="icon" id="downArrow" transform={(dropDown === 'linkAction')?('scale(1,-1) translate(0,2)'):""}  />
                           
                           </div>}
                           
                                        
                           <span className="inputField dropDownField dropDownBox ui" id={"inputField_linkAction_" + dimension.id}>
                           <span className="dropDown">
                             <span className="dropDownChoices">
                              <span className={"dropDownChoice ui"} onClick={() => onLinkAction('layer', 'Show Layer')}>{"Show Layer"}</span>
                              {!props.activeSectionObj.template && <span className={"dropDownChoice ui"} onClick={() => onLinkAction('page', 'Go to Page')}>{"Go to Page"}</span>}
                              <span className={"dropDownChoice ui"} onClick={() =>  onLinkAction('link', 'Go to Link')}>{"Go to Link"}</span>
                             </span>
                           </span>
                         </span> 

                          </div>

                          {interaction === 'Show Layer' && 
                          <span data-action="layer">

                              <div className={"settingsRow"} id="settingsRow_targetLayer">
                      
                                <span className="canvasLabel">Target Layer</span>
                                

                                

                                <div className="ui targetLayer dropDownBtn" onClick={(e) => handleDropDown(e, 'targetLayer')}>
                                {/* Make layer's existence variable */}
                                {props.componentDimensions.find(a => a.component === parseInt(parseLinkParams(dimension.component_link)['target'])) && parseLinkParams(dimension.component_link)['target'] ? 
                                  <div className="iconField fieldValue">
                                    {fileNameType(props.componentDimensions.find(a => a.component === parseInt(parseLinkParams(dimension.component_link)['target']))['name'], props.componentDimensions.find(a => a.component === parseInt(parseLinkParams(dimension.component_link)['target']))['layer_name']).map((obj2, j) => (<span key={"fileName_" + j}>{obj2}</span>))}
                                  </div> 
                                  : "Select Layer"}
                                  <Icons.ChevronDown className="icon" id="downArrow" transform={(dropDown === 'targetLayer')?('scale(1,-1) translate(0,2)'):""}  />
                                </div>
                                

                            
                              </div>


                              <span className="inputField dropDownField dropDownBox ui" id={"inputField_targetLayer_" + dimension.id}>
                              <span className="dropDown">
                                <span className="dropDownChoices">
                                {props.componentDimensions.filter(a => !a.background).sort((a,b) => b.component_ordering - a.component_ordering).map((obj, i) => <span key={'dropDown' + i} className={"dropDownChoice ui"} onClick={() => buildComponentLink('target', obj.component)}>
                                <div className="iconField fieldValue">{fileNameType(obj.name, obj.layer_name).map((obj2, j) => (<span key={"fileName_" + j}>{obj2}</span>))}</div>
                                </span>)}

                                </span>
                              </span>
                            </span> 


                              <div className="">
                                <span className="canvasLabel">Trigger Layer Behavior</span>

                                <div className="flex float">
                                <div className={"ui"}>
                                
                                <span>
                                <span className="formatLock ui">
                                <span 
                                onClick={(e) => buildComponentLink('toggle', 0)}
                                className={
                                    classNames(
                                      "btn1", 
                                      "autoWidth",
                                      ((parseLinkParams(dimension.component_link)['toggle'] !== '1')) && "on"
                                    )
                                  }>Remain On</span>
                                  <span 
                                  onClick={(e) => buildComponentLink('toggle', 1)}
                                  className={
                                    classNames(
                                      "btn1", 
                                      "autoWidth",
                                      (parseLinkParams(dimension.component_link)['toggle'] === '1') && "on"
                                    )
                                  }>Turn Off</span>
                              </span>
                                </span>
                                </div>
                                </div>
                              </div>

                              
                              {dimCopy.current && dimension.component_link && (parseLinkParams(dimension.component_link)['toggle'] !== '1') && <div className={classNames("settingsRow", "selectFileRow", parseLinkParams(dimCopy.current.component_link)['target'] !== undefined ? "on":"actionOff")}>
                                <span className="canvasLabel">Focus State</span>
                                <span>
                              
                                  {dimension.image_on ? <div onClick={() => onReplaceFile('focusFile')} className="iconField fieldValue">{fileNameType(dimension.name_on, null).map((obj2, j) => (<span key={"focusFile_" + j}>{obj2}</span>))}</div> : <span className="iconField fieldValue" onClick={() => onReplaceFile('focusFile')}>Add File</span>}


                                    <input type="file" style={{display: "none"}} id="focusFile" accept={"image/png, image/jpeg, image/webp"} onChange={(e) => handleLinkMediaAddReplace(dimension.id, e, null)} multiple={false} />
                                </span>
                                <span className="canvasLabel ui" onClick={() => handleLinkMediaAddReplace(dimension.id, null, true)}>Clear</span>
                              </div>}
                    


                                 
                       
                          
                          </span>}

                          {interaction === 'Go to Page' && 
                            <span data-action="page">
  
                            <div className={"settingsRow"} id="settingsRow_targetPage">
                      
                               <span className="canvasLabel">Target Page</span>
                              {/* Make page's existence variable */}
                                <div className="ui targetPage dropDownBtn" onClick={(e) => handleDropDown(e, 'targetPage')}>
                                {parseLinkParams(dimension.component_link)['page'] ? <div className="iconField fieldValue">
                        
                                  {flatHeadings && flatHeadings.find(a => a.page === parseInt(parseLinkParams(dimension.component_link)['page'])) && flatHeadings.find(a => a.page === parseInt(parseLinkParams(dimension.component_link)['page']))['heading']}
                                  
                                </div> : "Select Page"}
                                  <Icons.ChevronDown className="icon" id="downArrow" transform={(dropDown === 'targetPage')?('scale(1,-1) translate(0,2)'):""}  />
                                </div>
                                

                            
                              </div>


                              <span className="inputField dropDownField dropDownBox ui" id={"inputField_targetPage_" + dimension.id}>
                              <span className="dropDown">
                                <span className="dropDownChoices">
                          
                                {props.narrativeHeadings.sort((a,b) => a.ordering - b.ordering).map((obj, i) => <Fragment key={'dropDown' + i}>
                                <div className="dropDownChoice ui" onClick={() => buildComponentLink('page', obj.page)}>{obj.heading}</div>

                                {obj.subs && obj.subs.length > 0 && obj.subs.sort((a,b) => a.ordering - b.ordering).map((obj1, i) => <span key={'dropDown' + i} className={"dropDownChoice ui subChoice"} onClick={() => buildComponentLink('page', obj1.page)}>
                                <div className="">{obj1.heading}</div>
                                </span>)}

                                </Fragment>)}

                                </span>
                              </span>
                            </span> 
        
                               
                            
                            </span>}
                          
                            {interaction === 'Go to Link' && 
                              <span data-action="link">
    
                                  <div className={"settingsRow"}>
                          
                                    <span className="canvasLabel">Link to Module</span>
                                    <input type="text" key={dimension.id + '_link'} disabled={(dimension.popup)?('disabled'):(false)} defaultValue={dimension.component_link} id={'link_' + dimension.id} onChange={() => props.setUnSavedChanges(true)} />
                                
                                  </div>
          
                                 
                              
                              </span>}

                              {(dimension.component_link || interaction) && <div className="settingsRow">
                            
                              <span className="canvasLabel">Button Name (for iPad Controller)</span>
                              <input type="text" key={dimension.id + '_link_heading'} disabled={(dimension.popup)?('disabled'):(false)} defaultValue={dimension.component_link_heading} id={'link_heading_' + dimension.id} onChange={() => props.setUnSavedChanges(true)} />
                            </div>}
       


                       
                       </span>

                   </div>}
                   {/* INTERACTION Ends */}
                  

                  </div>



                  
                 
               
                 
                  
                  <div className="settingsRow" id="saveRow">
                      <div className={"closeFormBtn btn" + ((props.unSavedChanges) ? (" unsaved") : (" saved"))} onClick={() => props.unSavedChanges ? props.showSettings(dimension.id, true, null):null}>Save</div>
                     {dimension.file_format !== "grp" && !dimension.background && <div className="iconField ui rightNavDeleteBtn noSubEvents" onMouseEnter={(e) =>props.onMouseEnter(e, "Double click to delete")} onMouseLeave={() => props.onMouseLeave() } onDoubleClick={() => handleDeleteMedia(dimension.id, dimension.file_format)}><Icons.Delete className="icon"/><div className="canvasLabel">Delete File</div></div>}
                  </div>
                  
                </div>   
              </div>
            </div>
           </div>
           ):null
         )}
         
         </div>     
         
    

         </div>
        
    )
}

export default LayerSettings;
// <input type="text" id={"inputField_fontSize_text_" + dimension.id} defaultValue={getSelectedValue(dimension, 'font-size', 32)} key={dimension.html_text + "_" +  + props.versionNumber} onClick={(e) => handleDropDown(e, 'fontSize')} onChange={(e) => updateText('font-size', e.target.value)} />